import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Upload: any;
};

export type AccessMeeting = {
  __typename?: 'AccessMeeting';
  date?: Maybe<Scalars['DateTime']>;
  location?: Maybe<Scalars['String']>;
};

export type AccessMeetingInput = {
  date?: InputMaybe<Scalars['DateTime']>;
  location?: InputMaybe<Scalars['String']>;
};

export enum AccountCreatedConfirmation {
  Mail = 'MAIL',
  None = 'NONE'
}

export type AddViewingParticipantOptionsInput = {
  waitForNotification?: InputMaybe<Scalars['Boolean']>;
};

export enum AddViewingParticipantResponse {
  AlreadyRegistered = 'ALREADY_REGISTERED',
  FullyBooked = 'FULLY_BOOKED',
  MissingParameters = 'MISSING_PARAMETERS',
  Success = 'SUCCESS'
}

export enum AdditionalSpaceType {
  Balcony = 'BALCONY',
  None = 'NONE',
  Patio = 'PATIO',
  Terrace = 'TERRACE'
}

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  municipality?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  streetName?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type AggregatedEventDto = {
  __typename?: 'AggregatedEventDto';
  date: Scalars['DateTime'];
  deviceData?: Maybe<DeviceDataDto>;
  event: Scalars['String'];
  eventType: Scalars['String'];
  id: Scalars['ID'];
  page?: Maybe<Scalars['String']>;
  screen?: Maybe<Scalars['String']>;
  userData?: Maybe<UserDataDto>;
};

export type Area = {
  __typename?: 'Area';
  bounds: Bounds;
  children: Array<Area>;
  homeCount: Scalars['Int'];
  homes: Array<Home>;
  id: Scalars['ID'];
  name: Scalars['String'];
  parent?: Maybe<Area>;
  parentId?: Maybe<Scalars['ID']>;
  polygon: Array<Coordinate>;
  public: Scalars['Boolean'];
  root?: Maybe<Area>;
  rootId?: Maybe<Scalars['ID']>;
};


export type AreaChildrenArgs = {
  filter?: InputMaybe<AreaFilter>;
};

export type AreaFilter = {
  coversCoordinate?: InputMaybe<CoordinateInput>;
  includePrivate?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['ID']>;
};

export type AreaInput = {
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['ID']>;
  polygon?: InputMaybe<Array<CoordinateInput>>;
  public?: InputMaybe<Scalars['Boolean']>;
  uuid?: InputMaybe<Scalars['String']>;
};

export type Assessment = {
  __typename?: 'Assessment';
  buildingValue?: Maybe<Scalars['Float']>;
  fee?: Maybe<Scalars['Float']>;
  landValue?: Maybe<Scalars['Float']>;
  totalValue?: Maybe<Scalars['Float']>;
  typeCode?: Maybe<Scalars['String']>;
  valueYear?: Maybe<Scalars['Float']>;
  yearOfAssessment?: Maybe<Scalars['Int']>;
};

export type Association = {
  __typename?: 'Association';
  generalDescription?: Maybe<Scalars['String']>;
  indirectNetDebt?: Maybe<Scalars['Float']>;
  indirectNetDebtComment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  percentageOfAnnualFee?: Maybe<Scalars['Float']>;
  percentageOfAssociation?: Maybe<Scalars['Float']>;
  repairFund?: Maybe<Scalars['Float']>;
};

export type BankInformation = {
  __typename?: 'BankInformation';
  accountNumber?: Maybe<Scalars['String']>;
  clearingNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type BankInformationInput = {
  accountNumber: Scalars['String'];
  clearingNumber: Scalars['String'];
  name: Scalars['String'];
};

export enum BankidInitErrorCode {
  BankidError = 'BANKID_ERROR',
  IncorrectSsn = 'INCORRECT_SSN',
  Unknown = 'UNKNOWN'
}

export type BankidInitResponse = {
  __typename?: 'BankidInitResponse';
  autoStartToken: Scalars['String'];
  errorCode?: Maybe<BankidInitErrorCode>;
  sessionId: Scalars['String'];
  success: Scalars['Boolean'];
};

export enum BankidStatusErrorCode {
  LoginFailed = 'LOGIN_FAILED'
}

export type BankidStatusResponse = {
  __typename?: 'BankidStatusResponse';
  errorCode?: Maybe<BankidStatusErrorCode>;
  jwt?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  user?: Maybe<BankidUser>;
};

export type BankidUser = {
  __typename?: 'BankidUser';
  givenName: Scalars['String'];
  name: Scalars['String'];
  personalNumber: Scalars['String'];
  surname: Scalars['String'];
};

export type Bid = {
  __typename?: 'Bid';
  amount?: Maybe<Scalars['Int']>;
  bidderAlias?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isCanceled?: Maybe<Scalars['Boolean']>;
  stopped?: Maybe<Scalars['Boolean']>;
};

export enum BiddingState {
  Active = 'ACTIVE',
  ActiveHighestBid = 'ACTIVE_HIGHEST_BID',
  ActiveHistory = 'ACTIVE_HISTORY',
  Closed = 'CLOSED'
}

export type Bounds = {
  __typename?: 'Bounds';
  max: Coordinate;
  min: Coordinate;
};

export type Building = {
  __typename?: 'Building';
  beam?: Maybe<Scalars['String']>;
  externalSheetMetalWork?: Maybe<Scalars['String']>;
  facade?: Maybe<Scalars['String']>;
  floors?: Maybe<Scalars['Int']>;
  foundation?: Maybe<Scalars['String']>;
  foundationWall?: Maybe<Scalars['String']>;
  frame?: Maybe<Scalars['String']>;
  heating?: Maybe<Scalars['String']>;
  newConstruction?: Maybe<Scalars['Boolean']>;
  otherBuildings?: Maybe<Scalars['String']>;
  propertyDesignation?: Maybe<Scalars['String']>;
  renovations?: Maybe<Scalars['String']>;
  roof?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  ventilation?: Maybe<Scalars['String']>;
  windows?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

export type CrmAction = {
  __typename?: 'CRMAction';
  action: Scalars['String'];
  id: Scalars['ID'];
  target: Scalars['DateTime'];
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export enum ChatChangeOwnership {
  Release = 'RELEASE',
  Take = 'TAKE'
}

export type ChatMessage = {
  __typename?: 'ChatMessage';
  id: Scalars['ID'];
  message: Scalars['String'];
  recipient?: Maybe<User>;
  sender: User;
  timestamp: Scalars['DateTime'];
};

export type ChatOwnership = {
  __typename?: 'ChatOwnership';
  handled?: Maybe<Scalars['Boolean']>;
  homeId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['ID']>;
  streetAddress?: Maybe<Scalars['ID']>;
  userId?: Maybe<Scalars['ID']>;
};

export type ChatOwnershipDateFilter = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type ChatOwnershipFilter = {
  date?: InputMaybe<ChatOwnershipDateFilter>;
  includeHandled?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  ownership?: InputMaybe<ChatOwnershipType>;
  senderId?: InputMaybe<Scalars['ID']>;
};

export enum ChatOwnershipType {
  All = 'ALL',
  Me = 'ME',
  Others = 'OTHERS',
  Unassigned = 'UNASSIGNED'
}

export type ContractMeeting = {
  __typename?: 'ContractMeeting';
  date?: Maybe<Scalars['DateTime']>;
  location?: Maybe<Scalars['String']>;
};

export type ContractMeetingInput = {
  date?: InputMaybe<Scalars['DateTime']>;
  location?: InputMaybe<Scalars['String']>;
};

export type Coordinate = {
  __typename?: 'Coordinate';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type CoordinateInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type CreateTemporaryHousingInput = {
  city: Scalars['String'];
  email: Scalars['String'];
  endDate: Scalars['DateTime'];
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  rooms: Scalars['Int'];
  startDate: Scalars['DateTime'];
};

export type CreatedAtFilterOptions = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export enum DeleteAccount {
  Complete = 'COMPLETE',
  Home = 'HOME'
}

export type Description = {
  __typename?: 'Description';
  other?: Maybe<Scalars['String']>;
  short?: Maybe<Scalars['String']>;
};

export type DescriptionInput = {
  other?: InputMaybe<Scalars['String']>;
  short?: InputMaybe<Scalars['String']>;
};

export type Device = {
  __typename?: 'Device';
  fcmToken: Scalars['String'];
  notificationsPermission: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['ID'];
};

export type DeviceDataDto = {
  __typename?: 'DeviceDataDto';
  platformOs?: Maybe<Scalars['String']>;
  platformVersion?: Maybe<Scalars['String']>;
  screenHeight?: Maybe<Scalars['Float']>;
  screenWidth?: Maybe<Scalars['Float']>;
};

export type DeviceInput = {
  fcmToken: Scalars['String'];
  notificationsPermission?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type DevicesFilter = {
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Distribution = {
  __typename?: 'Distribution';
  distribution: Array<Scalars['Float']>;
  max: Scalars['Float'];
  min: Scalars['Float'];
};

export type Document = {
  __typename?: 'Document';
  category?: Maybe<Scalars['String']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Email = {
  __typename?: 'Email';
  email?: Maybe<Scalars['String']>;
};

export type EnergyDeclaration = {
  __typename?: 'EnergyDeclaration';
  completed?: Maybe<Scalars['String']>;
  consumption?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  energyClass?: Maybe<Scalars['String']>;
  energyPerformance?: Maybe<Scalars['String']>;
};

export enum EstimateType {
  Asap = 'ASAP',
  DontKnow = 'DONT_KNOW',
  WithinAYear = 'WITHIN_A_YEAR',
  WithinSixMonths = 'WITHIN_SIX_MONTHS'
}

export enum EventType {
  CrmCustomEntry = 'CRM_CUSTOM_ENTRY',
  CurrentTaskTransition = 'CURRENT_TASK_TRANSITION'
}

export type FilterFollowers = {
  active?: InputMaybe<Scalars['Boolean']>;
  areaIds?: InputMaybe<Array<Scalars['ID']>>;
  createdAt?: InputMaybe<CreatedAtFilterOptions>;
  email?: InputMaybe<Scalars['String']>;
  homeId?: InputMaybe<Scalars['ID']>;
  homeStates?: InputMaybe<Array<HomeState>>;
  latestCount?: InputMaybe<Scalars['Int']>;
  maxRooms?: InputMaybe<Scalars['Int']>;
  minRooms?: InputMaybe<Scalars['Int']>;
  public?: InputMaybe<Scalars['Boolean']>;
  unique?: InputMaybe<FollowerUniqueType>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type FilterHomeRequests = {
  homeId?: InputMaybe<Scalars['ID']>;
  requestType?: InputMaybe<HomeRequestType>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type FilterLogEntries = {
  includeCrmCustomActions?: InputMaybe<Scalars['Boolean']>;
};

export type FilterPublicFollowers = {
  active?: InputMaybe<Scalars['Boolean']>;
  areaIds?: InputMaybe<Array<Scalars['ID']>>;
  createdAt?: InputMaybe<CreatedAtFilterOptions>;
  email?: InputMaybe<Scalars['String']>;
  homeId?: InputMaybe<Scalars['ID']>;
  latestCount?: InputMaybe<Scalars['Int']>;
  maxRooms?: InputMaybe<Scalars['Int']>;
  minRooms?: InputMaybe<Scalars['Int']>;
  public?: InputMaybe<Scalars['Boolean']>;
  unique?: InputMaybe<FollowerUniqueType>;
};

export type Follower = {
  __typename?: 'Follower';
  active: Scalars['Boolean'];
  activeToggledAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  homeId: Scalars['ID'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  publicHome?: Maybe<PublicHome>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
};

export type FollowerComment = {
  __typename?: 'FollowerComment';
  comment: Scalars['String'];
};

export type FollowerCommentInput = {
  comment: Scalars['String'];
};

export type FollowerOptions = {
  filter?: InputMaybe<FilterFollowers>;
  orderBy?: InputMaybe<FollowerOrder>;
};

export enum FollowerOrder {
  UpdatedAt = 'UPDATED_AT'
}

export type FollowerRecommendation = {
  __typename?: 'FollowerRecommendation';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  publicHome: PublicHome;
  user: User;
};

export enum FollowerUniqueType {
  Latest = 'LATEST',
  None = 'NONE',
  Oldest = 'OLDEST'
}

export type Home = {
  __typename?: 'Home';
  accessMeeting: AccessMeeting;
  adApproved?: Maybe<Scalars['Boolean']>;
  adHideArea?: Maybe<Scalars['Boolean']>;
  adHideCommission?: Maybe<Scalars['Boolean']>;
  adPreviewUrl?: Maybe<Scalars['String']>;
  adUrl?: Maybe<Scalars['String']>;
  additionalSpace: Array<AdditionalSpaceType>;
  address: Address;
  area?: Maybe<Area>;
  areaId?: Maybe<Scalars['ID']>;
  areaSource?: Maybe<Scalars['String']>;
  askingPrice?: Maybe<Scalars['Float']>;
  askingPriceMax?: Maybe<Scalars['Float']>;
  assessment: Assessment;
  association: Association;
  backup?: Maybe<Realtor>;
  backupId?: Maybe<Scalars['ID']>;
  balcony?: Maybe<Scalars['Boolean']>;
  bankAccountNumber?: Maybe<Scalars['String']>;
  biddingState?: Maybe<BiddingState>;
  biddingUrl?: Maybe<Scalars['String']>;
  building: Building;
  buildingYear?: Maybe<Scalars['String']>;
  client?: Maybe<OnboardingClient>;
  closingPrice?: Maybe<Scalars['Float']>;
  contractDate?: Maybe<Scalars['DateTime']>;
  contractMeeting: ContractMeeting;
  contract_read?: Maybe<Scalars['Boolean']>;
  coordinate: Coordinate;
  created: Scalars['DateTime'];
  description: Description;
  descriptionOther?: Maybe<Scalars['String']>;
  descriptionShort?: Maybe<Scalars['String']>;
  descriptiveLines: Array<Scalars['String']>;
  documents: Array<Document>;
  elevator?: Maybe<Scalars['Boolean']>;
  energyDeclaration: EnergyDeclaration;
  floor?: Maybe<Scalars['Int']>;
  floorMax?: Maybe<Scalars['Int']>;
  followerCount?: Maybe<Scalars['Int']>;
  followers: Array<Follower>;
  id?: Maybe<Scalars['ID']>;
  images: Array<Image>;
  insurance: Insurance;
  leasehold: Leasehold;
  livingArea?: Maybe<Scalars['Float']>;
  livingAreaMax?: Maybe<Scalars['Float']>;
  logEntries: Array<HomeLogEntry>;
  marketingDescription?: Maybe<Scalars['String']>;
  marketingEnabled?: Maybe<Scalars['Boolean']>;
  marketingTitle?: Maybe<Scalars['String']>;
  monthlyFee?: Maybe<Scalars['Float']>;
  monthlyFeeDescription?: Maybe<Scalars['String']>;
  monthlyFeeMax?: Maybe<Scalars['Float']>;
  mortgages: Array<Mortgage>;
  newConstructionAvailable?: Maybe<Scalars['Int']>;
  newConstructionCount?: Maybe<Scalars['Int']>;
  newConstructionEstCompletionDate?: Maybe<Scalars['DateTime']>;
  newConstructionHome?: Maybe<Scalars['Boolean']>;
  newConstructionHouseView?: Maybe<Scalars['String']>;
  newConstructionProjectName?: Maybe<Scalars['String']>;
  newConstructionSubTenure?: Maybe<TenureType>;
  notes?: Maybe<Scalars['String']>;
  numberOfRooms?: Maybe<Scalars['Float']>;
  numberOfRoomsMax?: Maybe<Scalars['Float']>;
  openMarket?: Maybe<OpenMarket>;
  operatingCost: OperatingCost;
  otherArea?: Maybe<Scalars['Float']>;
  patio?: Maybe<Scalars['Boolean']>;
  pawned?: Maybe<Scalars['Boolean']>;
  photoShoot: PhotoShoot;
  photosApproved?: Maybe<Scalars['Boolean']>;
  plot: Plot;
  preferentialAndCommunityEnrollments: Scalars['String'];
  publishingDate?: Maybe<Scalars['DateTime']>;
  realtor?: Maybe<Realtor>;
  realtorId?: Maybe<Scalars['ID']>;
  requests: Array<HomeRequest>;
  rooms: Array<Room>;
  rootArea?: Maybe<Area>;
  sellingEstimate?: Maybe<EstimateType>;
  settlement_reviewed?: Maybe<Scalars['Boolean']>;
  showYourHomePreference?: Maybe<ShowYourHomeRequest>;
  sortingTimestamp: Scalars['DateTime'];
  state: HomeState;
  stateChanged?: Maybe<HomeLogEntry>;
  surrounding: Surrounding;
  tags: Array<TagType>;
  tenure?: Maybe<TenureType>;
  terrace?: Maybe<Scalars['Boolean']>;
  timeline: Timeline;
  type?: Maybe<HomeType>;
  undisclosedAddress: UndisclosedAddress;
  urlExtension?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
  valuationMeeting: ValuationMeetingInfo;
  viewings: Array<Viewing>;
  viewingsSummary?: Maybe<Scalars['String']>;
  visitCount?: Maybe<Scalars['Int']>;
  visitorCount?: Maybe<Scalars['Int']>;
  vitecEstateId?: Maybe<Scalars['String']>;
  waterAndSewage: WaterAndSewage;
};

export type HomeDateRangeFilter = {
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export type HomeFilter = {
  dateRange?: InputMaybe<HomeDateRangeFilter>;
  hasArea?: InputMaybe<Scalars['Boolean']>;
  homeStates?: InputMaybe<Array<HomeState>>;
  rootAreas?: InputMaybe<Array<Scalars['ID']>>;
};

export type HomeInput = {
  accessMeeting?: InputMaybe<AccessMeetingInput>;
  adApproved?: InputMaybe<Scalars['Boolean']>;
  adHideArea?: InputMaybe<Scalars['Boolean']>;
  adHideCommission?: InputMaybe<Scalars['Boolean']>;
  adUrl?: InputMaybe<Scalars['String']>;
  additionalSpace?: InputMaybe<Array<AdditionalSpaceType>>;
  areaId?: InputMaybe<Scalars['ID']>;
  areaSource?: InputMaybe<Scalars['String']>;
  askingPrice?: InputMaybe<Scalars['Float']>;
  askingPriceMax?: InputMaybe<Scalars['Float']>;
  balcony?: InputMaybe<Scalars['Boolean']>;
  bankAccountNumber?: InputMaybe<Scalars['String']>;
  biddingState?: InputMaybe<Scalars['String']>;
  biddingUrl?: InputMaybe<Scalars['String']>;
  buildingYear?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  client?: InputMaybe<OnboardingClient>;
  closingPrice?: InputMaybe<Scalars['Float']>;
  contractDate?: InputMaybe<Scalars['DateTime']>;
  contractMeeting?: InputMaybe<ContractMeetingInput>;
  contractRead?: InputMaybe<Scalars['Boolean']>;
  coordinate?: InputMaybe<CoordinateInput>;
  description?: InputMaybe<DescriptionInput>;
  descriptiveLines?: InputMaybe<Array<Scalars['String']>>;
  elevator?: InputMaybe<Scalars['Boolean']>;
  floor?: InputMaybe<Scalars['Int']>;
  floorMax?: InputMaybe<Scalars['Int']>;
  livingArea?: InputMaybe<Scalars['Float']>;
  livingAreaMax?: InputMaybe<Scalars['Float']>;
  marketingDescription?: InputMaybe<Scalars['String']>;
  marketingEnabled?: InputMaybe<Scalars['Boolean']>;
  marketingTitle?: InputMaybe<Scalars['String']>;
  monthlyFee?: InputMaybe<Scalars['Float']>;
  monthlyFeeDescription?: InputMaybe<Scalars['String']>;
  monthlyFeeMax?: InputMaybe<Scalars['Float']>;
  newConstructionAvailable?: InputMaybe<Scalars['Int']>;
  newConstructionCount?: InputMaybe<Scalars['Int']>;
  newConstructionEstCompletionDate?: InputMaybe<Scalars['DateTime']>;
  newConstructionHouseView?: InputMaybe<Scalars['String']>;
  newConstructionProjectName?: InputMaybe<Scalars['String']>;
  newConstructionSubTenure?: InputMaybe<TenureType>;
  notes?: InputMaybe<Scalars['String']>;
  notifyStateChange?: InputMaybe<Scalars['Boolean']>;
  numberOfRooms?: InputMaybe<Scalars['Float']>;
  numberOfRoomsMax?: InputMaybe<Scalars['Float']>;
  openMarket?: InputMaybe<OpenMarketInput>;
  otherArea?: InputMaybe<Scalars['Float']>;
  patio?: InputMaybe<Scalars['Boolean']>;
  photoShoot?: InputMaybe<PhotoShootInput>;
  photosApproved?: InputMaybe<Scalars['Boolean']>;
  plotArea?: InputMaybe<Scalars['Float']>;
  publishingDate?: InputMaybe<Scalars['DateTime']>;
  sellingEstimate?: InputMaybe<EstimateType>;
  settlementReviewed?: InputMaybe<Scalars['Boolean']>;
  showYourHomePreference?: InputMaybe<ShowYourHomeRequest>;
  sortingTimestamp?: InputMaybe<Scalars['DateTime']>;
  state?: InputMaybe<HomeState>;
  streetAddress?: InputMaybe<Scalars['String']>;
  streetName?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagType>>;
  tenure?: InputMaybe<TenureType>;
  terrace?: InputMaybe<Scalars['Boolean']>;
  timeline?: InputMaybe<TimelineInput>;
  type?: InputMaybe<HomeType>;
  undisclosedAddress?: InputMaybe<UndisclosedAddressInput>;
  urlExtension?: InputMaybe<Scalars['String']>;
  valuationMeeting?: InputMaybe<ValuationMeetingInfoInput>;
  viewingsSummary?: InputMaybe<Scalars['String']>;
  vitecEstateId?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type HomeLogEntry = {
  __typename?: 'HomeLogEntry';
  id: Scalars['ID'];
  message: Scalars['String'];
  timestamp: Scalars['DateTime'];
};

export type HomeMetricDistribution = {
  __typename?: 'HomeMetricDistribution';
  askingPrice?: Maybe<Distribution>;
  count: Scalars['Int'];
  livingArea?: Maybe<Distribution>;
  rooms?: Maybe<Distribution>;
};

export type HomeRequest = {
  __typename?: 'HomeRequest';
  createdAt: Scalars['DateTime'];
  homeId: Scalars['ID'];
  requestType: HomeRequestType;
  userId?: Maybe<Scalars['ID']>;
};

export type HomeRequestPhotos = {
  __typename?: 'HomeRequestPhotos';
  count: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  homeId: Scalars['ID'];
};

export enum HomeRequestType {
  Photos = 'PHOTOS',
  Price = 'PRICE',
  SaleDate = 'SALE_DATE'
}

export enum HomeState {
  Hidden = 'HIDDEN',
  None = 'NONE',
  OpenMarket = 'OPEN_MARKET',
  Premarket = 'PREMARKET',
  PremarketLight = 'PREMARKET_LIGHT',
  Sold = 'SOLD',
  Withdrawn = 'WITHDRAWN'
}

export enum HomeType {
  Apartment = 'APARTMENT',
  Cottage = 'COTTAGE',
  House = 'HOUSE',
  TerraceHouse = 'TERRACE_HOUSE',
  Townhouse = 'TOWNHOUSE',
  TwinHouse = 'TWIN_HOUSE'
}

export type Homes = {
  __typename?: 'Homes';
  homes?: Maybe<Array<Maybe<Home>>>;
};

export type Image = {
  __typename?: 'Image';
  id: Scalars['String'];
  isFloorPlan?: Maybe<Scalars['Boolean']>;
};

export type InputPublicHomeImages = {
  first?: InputMaybe<Scalars['Int']>;
};

export type InputSessionCreateUser = {
  bankIdJwt?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  name: Scalars['String'];
  options?: InputMaybe<NewUserOptions>;
  password: Scalars['String'];
  phone: Scalars['String'];
};

export type InputSessionEmailPassword = {
  email: Scalars['String'];
  options?: InputMaybe<LoginOptions>;
  password: Scalars['String'];
};

export type InputSessionLoginEmail = {
  challengeResponseNewAccountRedirectUrl?: InputMaybe<Scalars['String']>;
  challengeResponseRedirectUrl?: InputMaybe<Scalars['String']>;
  challengeResponseUrl?: InputMaybe<Scalars['String']>;
  confirmation?: InputMaybe<AccountCreatedConfirmation>;
  createNewAccountIfNotFound?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
};

export type InputSessionLoginEmailChallenge = {
  challenge: Scalars['String'];
};

export type InputSessionMutation = {
  loginEmail?: InputMaybe<InputSessionLoginEmail>;
  loginEmailChallenge?: InputMaybe<InputSessionLoginEmailChallenge>;
  logout?: InputMaybe<Scalars['Boolean']>;
};

export type InputSessionRespondLoginChallenge = {
  challenge: Scalars['String'];
};

export type Insurance = {
  __typename?: 'Insurance';
  amount?: Maybe<Scalars['Float']>;
  company?: Maybe<Scalars['String']>;
  fullValue?: Maybe<Scalars['Boolean']>;
};

export type Job = {
  __typename?: 'Job';
  id: Scalars['ID'];
  state?: Maybe<Scalars['String']>;
};

export enum JobType {
  SyncAreas = 'SYNC_AREAS'
}

export type Leasehold = {
  __typename?: 'Leasehold';
  expiryDate?: Maybe<Scalars['DateTime']>;
  fee?: Maybe<Scalars['String']>;
};

export type LogEntry = {
  __typename?: 'LogEntry';
  id: Scalars['ID'];
  message: Scalars['String'];
  meta?: Maybe<Scalars['String']>;
  originator?: Maybe<User>;
  timestamp: Scalars['DateTime'];
  type: EventType;
};

export type LogEntryInput = {
  message: Scalars['String'];
  meta?: InputMaybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  type: EventType;
};

export type LogEntryOptions = {
  filter?: InputMaybe<FilterLogEntries>;
};

export type LoginOptions = {
  client?: InputMaybe<Scalars['String']>;
};

export type Mortgage = {
  __typename?: 'Mortgage';
  amount?: Maybe<Scalars['Float']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']>;
  addDevice: Device;
  addViewingParticipant?: Maybe<AddViewingParticipantResponse>;
  approvePhotos: Home;
  approvePremarketAd: Home;
  assignmentContractSent: Home;
  banUser?: Maybe<Scalars['ID']>;
  bankidAuthenticateInit: BankidInitResponse;
  bookPhotoShoot: Home;
  bookValuationMeeting: Home;
  bumpHome: Home;
  callMe: Scalars['Boolean'];
  chatAdminister?: Maybe<Scalars['ID']>;
  contractSigned: Scalars['String'];
  createCRMAction?: Maybe<CrmAction>;
  createHomeRequest: HomeRequest;
  createNewConstructionHome: NewConstructionHome;
  createOpenMarketRedirect: OpenMarketRedirect;
  createOpportunity: Opportunity;
  createTemporaryHousing?: Maybe<TemporaryHousingEntry>;
  createUser?: Maybe<User>;
  createUserLabel?: Maybe<UserLabel>;
  deleteAccount: Scalars['Boolean'];
  deleteArea?: Maybe<Scalars['Boolean']>;
  deleteCRMAction?: Maybe<Scalars['ID']>;
  deleteDevice: Scalars['Boolean'];
  deleteFollower: Follower;
  deleteHomeOwner: Home;
  deleteLogEntry?: Maybe<LogEntry>;
  deleteNewConstructionHome: Scalars['Int'];
  deleteOpenMarketRedirect: OpenMarketRedirect;
  deleteOpportunity?: Maybe<Scalars['Int']>;
  deleteSearch: Search;
  deleteUser?: Maybe<Scalars['ID']>;
  deleteUserLabel?: Maybe<Scalars['ID']>;
  describeHome: Home;
  flushVitec: Scalars['Boolean'];
  followHome?: Maybe<Follower>;
  heldPhotoShoot: Scalars['String'];
  heldStaging: Scalars['String'];
  heldValuationMeeting: Scalars['String'];
  informationForValuationMeeting: Home;
  initiatePasswordReset: Scalars['Boolean'];
  login?: Maybe<Scalars['String']>;
  makePhotosAvailable: Scalars['String'];
  makePremarketAdAvailable: Scalars['String'];
  markAllChatAsRead?: Maybe<Scalars['Boolean']>;
  markChatAsHandled: Scalars['Boolean'];
  newArea?: Maybe<Area>;
  onboard: Home;
  planForOpenMarket: Home;
  read: Home;
  readContract: Home;
  requestInformationForValuationMeeting: Scalars['String'];
  requestPhotos?: Maybe<Scalars['Boolean']>;
  resetPassword: Scalars['Boolean'];
  reviewedSettlement: Home;
  saveSearch?: Maybe<Search>;
  sendChatMessage: ChatMessage;
  sendChatReminder: Scalars['Boolean'];
  sendDescriptiveLines: Home;
  session?: Maybe<Session>;
  sessionRespondLoginChallenge?: Maybe<Scalars['Boolean']>;
  setBankInformation: User;
  setPhotoShoot: Scalars['String'];
  setStaging: Scalars['String'];
  setValuationMeeting: Scalars['String'];
  showYourHome: Home;
  syncFollower: SyncFollowerErrors;
  syncImages: Scalars['Boolean'];
  updateArea?: Maybe<Area>;
  updateCRMAction?: Maybe<CrmAction>;
  updateDevice: Device;
  updateFollower: Follower;
  updateFollowerComment?: Maybe<FollowerComment>;
  updateGeoJson?: Maybe<Scalars['String']>;
  updateHome: Home;
  updateNewConstructionHome: NewConstructionHome;
  updateOpenMarketRedirect: OpenMarketRedirect;
  updateOpportunity: Opportunity;
  updateTaskState: Timeline;
  updateUser?: Maybe<User>;
  updateUserFile?: Maybe<UserFile>;
  updateUserLabel?: Maybe<Scalars['Int']>;
  uploadUserFile?: Maybe<UserFile>;
  valuationMeetingSummaryRead: Home;
};


export type MutationAddDeviceArgs = {
  input: DeviceInput;
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationAddViewingParticipantArgs = {
  homeId?: InputMaybe<Scalars['ID']>;
  input: ViewingParticipantInput;
  options?: InputMaybe<AddViewingParticipantOptionsInput>;
  timeSlotId: Scalars['ID'];
  viewingId: Scalars['ID'];
};


export type MutationBanUserArgs = {
  userId: Scalars['ID'];
};


export type MutationBankidAuthenticateInitArgs = {
  pin: Scalars['String'];
};


export type MutationBookPhotoShootArgs = {
  request: PhotoShootRequest;
};


export type MutationBookValuationMeetingArgs = {
  request: ValuationMeetingRequest;
};


export type MutationBumpHomeArgs = {
  homeId: Scalars['ID'];
};


export type MutationCallMeArgs = {
  phoneNumber: Scalars['String'];
};


export type MutationChatAdministerArgs = {
  ownerId?: InputMaybe<Scalars['ID']>;
  type: ChatChangeOwnership;
  userId: Scalars['ID'];
};


export type MutationCreateCrmActionArgs = {
  id: Scalars['ID'];
  input: NewCrmActionInput;
};


export type MutationCreateHomeRequestArgs = {
  input: NewHomeRequestInput;
};


export type MutationCreateNewConstructionHomeArgs = {
  newHome?: InputMaybe<NewConstructionHomeInput>;
};


export type MutationCreateOpenMarketRedirectArgs = {
  redirect: OpenMarketRedirectInput;
};


export type MutationCreateOpportunityArgs = {
  homeId: Scalars['ID'];
  input: OpportunityInput;
};


export type MutationCreateTemporaryHousingArgs = {
  input: CreateTemporaryHousingInput;
};


export type MutationCreateUserArgs = {
  homeInput?: InputMaybe<NewHomeInput>;
  input: NewUserInput;
  options?: InputMaybe<NewUserOptions>;
};


export type MutationCreateUserLabelArgs = {
  input: NewUserLabelInput;
};


export type MutationDeleteAccountArgs = {
  kind: DeleteAccount;
  userId: Scalars['ID'];
};


export type MutationDeleteAreaArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCrmActionArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDeviceArgs = {
  fcmToken: Scalars['String'];
};


export type MutationDeleteFollowerArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteHomeOwnerArgs = {
  homeId: Scalars['ID'];
};


export type MutationDeleteLogEntryArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteNewConstructionHomeArgs = {
  deleteLinkedHome?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type MutationDeleteOpenMarketRedirectArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteOpportunityArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSearchArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserArgs = {
  userId: Scalars['ID'];
};


export type MutationDeleteUserLabelArgs = {
  id: Scalars['ID'];
};


export type MutationDescribeHomeArgs = {
  tags: Array<TagType>;
};


export type MutationFlushVitecArgs = {
  userId: Scalars['ID'];
};


export type MutationFollowHomeArgs = {
  homeId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationInformationForValuationMeetingArgs = {
  info: ValuationMeetingInfoInput;
};


export type MutationInitiatePasswordResetArgs = {
  email: Scalars['String'];
};


export type MutationLoginArgs = {
  email: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  options?: InputMaybe<LoginOptions>;
  password: Scalars['String'];
};


export type MutationMarkAllChatAsReadArgs = {
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationMarkChatAsHandledArgs = {
  handled: Scalars['Boolean'];
  senderId: Scalars['ID'];
};


export type MutationNewAreaArgs = {
  input: AreaInput;
};


export type MutationOnboardArgs = {
  home?: InputMaybe<HomeInput>;
  input?: InputMaybe<OnboardInput>;
};


export type MutationPlanForOpenMarketArgs = {
  request: OpenMarketRequest;
};


export type MutationReadArgs = {
  taskType: TaskType;
};


export type MutationRequestPhotosArgs = {
  homeId: Scalars['ID'];
};


export type MutationResetPasswordArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  token: Scalars['String'];
};


export type MutationSaveSearchArgs = {
  input: SearchInput;
};


export type MutationSendChatMessageArgs = {
  message: Scalars['String'];
  to?: InputMaybe<Scalars['ID']>;
};


export type MutationSendChatReminderArgs = {
  userId: Scalars['ID'];
};


export type MutationSendDescriptiveLinesArgs = {
  lines: Array<Scalars['String']>;
};


export type MutationSessionArgs = {
  createNewIfNotFound?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  ip?: InputMaybe<Scalars['String']>;
  mutation?: InputMaybe<InputSessionMutation>;
  privateUuid?: InputMaybe<Scalars['ID']>;
  realm?: InputMaybe<Scalars['String']>;
  ua?: InputMaybe<Scalars['String']>;
};


export type MutationSessionRespondLoginChallengeArgs = {
  input: InputSessionRespondLoginChallenge;
};


export type MutationSetBankInformationArgs = {
  bankInformation: BankInformationInput;
  userId: Scalars['ID'];
};


export type MutationSetPhotoShootArgs = {
  date: Scalars['DateTime'];
};


export type MutationSetStagingArgs = {
  date: Scalars['DateTime'];
};


export type MutationSetValuationMeetingArgs = {
  date: Scalars['DateTime'];
  location: Scalars['String'];
};


export type MutationShowYourHomeArgs = {
  request?: InputMaybe<ShowYourHomeRequest>;
};


export type MutationSyncFollowerArgs = {
  email: Scalars['String'];
};


export type MutationSyncImagesArgs = {
  homeId: Scalars['ID'];
};


export type MutationUpdateAreaArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input: AreaInput;
};


export type MutationUpdateCrmActionArgs = {
  id: Scalars['ID'];
  input: UpdatedCrmActionInput;
};


export type MutationUpdateDeviceArgs = {
  input: DeviceInput;
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateFollowerArgs = {
  id: Scalars['ID'];
  input?: InputMaybe<UpdatedFollowerInput>;
};


export type MutationUpdateFollowerCommentArgs = {
  email: Scalars['String'];
  input: FollowerCommentInput;
};


export type MutationUpdateGeoJsonArgs = {
  deleteMissing: Scalars['Boolean'];
  dryRun: Scalars['Boolean'];
  geoJson: Scalars['String'];
};


export type MutationUpdateHomeArgs = {
  homeId: Scalars['ID'];
  input: HomeInput;
};


export type MutationUpdateNewConstructionHomeArgs = {
  id: Scalars['ID'];
  updatedHome: NewConstructionHomeInput;
};


export type MutationUpdateOpenMarketRedirectArgs = {
  id: Scalars['ID'];
  redirect: OpenMarketRedirectInput;
};


export type MutationUpdateOpportunityArgs = {
  id: Scalars['ID'];
  input: OpportunityInput;
};


export type MutationUpdateTaskStateArgs = {
  completed: Scalars['String'];
  phaseType: PhaseType;
  taskState: TaskState;
  taskType: TaskType;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateUserArgs = {
  input: UpdatedUserInput;
  options?: InputMaybe<UpdatedUserInputOptions>;
  userId: Scalars['ID'];
};


export type MutationUpdateUserFileArgs = {
  input: UpdateUserFileInput;
};


export type MutationUpdateUserLabelArgs = {
  id: Scalars['ID'];
  input: UpdatedUserLabelInput;
};


export type MutationUploadUserFileArgs = {
  input: UploadUserFileInput;
};

export type NewCrmActionInput = {
  action: Scalars['String'];
  target: Scalars['DateTime'];
};

export type NewConstructionHome = {
  __typename?: 'NewConstructionHome';
  home?: Maybe<Home>;
  homeId: Scalars['ID'];
  id: Scalars['ID'];
  linkedHomeId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type NewConstructionHomeInput = {
  adHideArea?: InputMaybe<Scalars['Boolean']>;
  areaId?: InputMaybe<Scalars['ID']>;
  askingPrice?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['Float']>;
  homeId?: InputMaybe<Scalars['ID']>;
  homeState?: InputMaybe<HomeState>;
  linkedHomeId?: InputMaybe<Scalars['ID']>;
  livingArea?: InputMaybe<Scalars['Float']>;
  monthlyFee?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  newConstructionEstCompletionDate?: InputMaybe<Scalars['DateTime']>;
  numberOfRooms?: InputMaybe<Scalars['Float']>;
  plotArea?: InputMaybe<Scalars['Float']>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  tenure?: InputMaybe<TenureType>;
  type?: InputMaybe<HomeType>;
  vitecEstateId?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type NewHomeInput = {
  tenure: TenureType;
};

export type NewHomeRequestInput = {
  homeId: Scalars['ID'];
  requestType: HomeRequestType;
  userId: Scalars['ID'];
};

export type NewUserInput = {
  email: Scalars['String'];
  name: Scalars['String'];
  personalIdentityNumber: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

export type NewUserLabelInput = {
  label: Scalars['String'];
  teamsHook?: InputMaybe<Scalars['String']>;
};

export type NewUserOptions = {
  allowReuseAccountWithoutHome?: InputMaybe<Scalars['Boolean']>;
  client?: InputMaybe<Scalars['String']>;
  context?: InputMaybe<Scalars['String']>;
};

export type OnboardInput = {
  additionalSpace?: InputMaybe<Array<AdditionalSpaceType>>;
  areaId?: InputMaybe<Scalars['ID']>;
  balcony?: InputMaybe<Scalars['Boolean']>;
  city: Scalars['String'];
  client?: InputMaybe<OnboardingClient>;
  elevator?: InputMaybe<Scalars['Boolean']>;
  floor?: InputMaybe<Scalars['Int']>;
  livingArea: Scalars['Float'];
  numberOfRooms: Scalars['Float'];
  otherArea?: InputMaybe<Scalars['Float']>;
  patio?: InputMaybe<Scalars['Boolean']>;
  plotArea?: InputMaybe<Scalars['Float']>;
  sellingEstimate?: InputMaybe<EstimateType>;
  streetAddress: Scalars['String'];
  tenure: TenureType;
  terrace?: InputMaybe<Scalars['Boolean']>;
  type: HomeType;
  zipCode?: InputMaybe<Scalars['String']>;
};

export enum OnboardingClient {
  App = 'APP',
  Web = 'WEB'
}

export type OpenMarket = {
  __typename?: 'OpenMarket';
  request?: Maybe<OpenMarketRequest>;
};

export type OpenMarketInput = {
  request?: InputMaybe<OpenMarketRequest>;
};

export type OpenMarketRedirect = {
  __typename?: 'OpenMarketRedirect';
  id: Scalars['ID'];
  identifier: Scalars['String'];
  url: Scalars['String'];
};

export type OpenMarketRedirectInput = {
  identifier?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export enum OpenMarketRequest {
  Asap = 'ASAP',
  MoreInfo = 'MORE_INFO'
}

export type OperatingCost = {
  __typename?: 'OperatingCost';
  chimneySweeping?: Maybe<Scalars['Float']>;
  commentary?: Maybe<Scalars['String']>;
  electricity?: Maybe<Scalars['Float']>;
  heating?: Maybe<Scalars['Float']>;
  insurance?: Maybe<Scalars['Float']>;
  maintenance?: Maybe<Scalars['Float']>;
  other?: Maybe<Scalars['Float']>;
  residents?: Maybe<Scalars['Int']>;
  roadCharge?: Maybe<Scalars['Float']>;
  roadCommunity?: Maybe<Scalars['Float']>;
  sanitation?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  waterAndSewage?: Maybe<Scalars['Float']>;
};

export type Opportunity = {
  __typename?: 'Opportunity';
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  read: Scalars['Boolean'];
  roomType?: Maybe<RoomType>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OpportunityInput = {
  content?: InputMaybe<Scalars['String']>;
  read?: InputMaybe<Scalars['Boolean']>;
  roomType?: InputMaybe<RoomType>;
  title?: InputMaybe<Scalars['String']>;
};

export type Owner = {
  __typename?: 'Owner';
  name?: Maybe<Scalars['String']>;
  personalNumber?: Maybe<Scalars['String']>;
};

export type Ownership = {
  __typename?: 'Ownership';
  hasMoreThanOneOwner?: Maybe<Scalars['Boolean']>;
  sellerIsOwner?: Maybe<Scalars['Boolean']>;
};

export type OwnershipInput = {
  hasMoreThanOneOwner?: InputMaybe<Scalars['Boolean']>;
  sellerIsOwner?: InputMaybe<Scalars['Boolean']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['ID']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['ID']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Phase = {
  __typename?: 'Phase';
  tasks: Array<Task>;
  type: PhaseType;
};

export enum PhaseType {
  Access = 'ACCESS',
  Contract = 'CONTRACT',
  GetStarted = 'GET_STARTED',
  OnYourWay = 'ON_YOUR_WAY',
  OpenMarket = 'OPEN_MARKET',
  Premarket = 'PREMARKET'
}

export type Photo = {
  __typename?: 'Photo';
  url?: Maybe<Scalars['String']>;
};

export type PhotoShoot = {
  __typename?: 'PhotoShoot';
  approved?: Maybe<Scalars['Boolean']>;
  includeStaging?: Maybe<Scalars['Boolean']>;
  photoShootDate?: Maybe<Scalars['DateTime']>;
  photographer?: Maybe<Scalars['String']>;
  request?: Maybe<PhotoShootRequest>;
  stagingDate?: Maybe<Scalars['DateTime']>;
  stylist?: Maybe<Scalars['String']>;
};

export type PhotoShootInput = {
  includeStaging?: InputMaybe<Scalars['Boolean']>;
  photoShootDate?: InputMaybe<Scalars['DateTime']>;
  photographer?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<PhotoShootRequest>;
  stagingDate?: InputMaybe<Scalars['DateTime']>;
  stylist?: InputMaybe<Scalars['String']>;
};

export enum PhotoShootRequest {
  MoreInfo = 'MORE_INFO',
  NoStyling = 'NO_STYLING',
  WantStyling = 'WANT_STYLING'
}

export type Plot = {
  __typename?: 'Plot';
  area?: Maybe<Scalars['Float']>;
};

export type PublicFollower = {
  __typename?: 'PublicFollower';
  createdAt: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  homeId: Scalars['ID'];
  id: Scalars['ID'];
};

export type PublicFollowerOptions = {
  filter?: InputMaybe<FilterPublicFollowers>;
};

export type PublicHome = {
  __typename?: 'PublicHome';
  adHideArea?: Maybe<Scalars['Boolean']>;
  adHideCommission?: Maybe<Scalars['Boolean']>;
  address: Address;
  area?: Maybe<Area>;
  areaId?: Maybe<Scalars['ID']>;
  areaSource?: Maybe<Scalars['String']>;
  askingPrice?: Maybe<Scalars['Float']>;
  askingPriceMax?: Maybe<Scalars['Float']>;
  assessment: Assessment;
  association: Association;
  backup?: Maybe<Realtor>;
  backupId?: Maybe<Scalars['ID']>;
  balcony?: Maybe<Scalars['Boolean']>;
  biddingState: BiddingState;
  biddingUrl?: Maybe<Scalars['String']>;
  bids: Array<Bid>;
  building: Building;
  closingPrice?: Maybe<Scalars['Float']>;
  coordinate?: Maybe<Coordinate>;
  created: Scalars['DateTime'];
  description: Description;
  documents: Array<Document>;
  elevator?: Maybe<Scalars['Boolean']>;
  energyDeclaration: EnergyDeclaration;
  floor?: Maybe<Scalars['Int']>;
  floorMax?: Maybe<Scalars['Int']>;
  followerCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  images: Array<Image>;
  insurance: Insurance;
  leasehold: Leasehold;
  livingArea?: Maybe<Scalars['Float']>;
  livingAreaMax?: Maybe<Scalars['Float']>;
  monthlyFee?: Maybe<Scalars['Float']>;
  monthlyFeeComment?: Maybe<Scalars['String']>;
  monthlyFeeMax?: Maybe<Scalars['Float']>;
  mortgages: Array<Mortgage>;
  newConstruction?: Maybe<Scalars['Boolean']>;
  newConstructionAvailable?: Maybe<Scalars['Int']>;
  newConstructionCount?: Maybe<Scalars['Int']>;
  newConstructionEstCompletionDate?: Maybe<Scalars['DateTime']>;
  newConstructionHome?: Maybe<Scalars['Boolean']>;
  newConstructionHouseView?: Maybe<Scalars['String']>;
  newConstructionProjectName?: Maybe<Scalars['String']>;
  newConstructionSubTenure?: Maybe<TenureType>;
  numberOfRooms?: Maybe<Scalars['Float']>;
  numberOfRoomsMax?: Maybe<Scalars['Float']>;
  operatingCost: OperatingCost;
  otherArea?: Maybe<Scalars['Float']>;
  patio?: Maybe<Scalars['Boolean']>;
  pawned?: Maybe<Scalars['Boolean']>;
  photoRequestCount?: Maybe<Scalars['Int']>;
  plot: Plot;
  preferentialAndCommunityEnrollments?: Maybe<Scalars['String']>;
  realtor?: Maybe<Realtor>;
  realtorId?: Maybe<Scalars['ID']>;
  rooms: Array<Room>;
  similarHomes: Array<PublicHomeLikeness>;
  sortingTimestamp: Scalars['DateTime'];
  state: HomeState;
  surrounding: Surrounding;
  tags: Array<TagType>;
  tenure?: Maybe<TenureType>;
  terrace?: Maybe<Scalars['Boolean']>;
  type?: Maybe<HomeType>;
  undisclosedAddress?: Maybe<UndisclosedAddress>;
  urlExtension?: Maybe<Scalars['String']>;
  viewings: Array<Viewing>;
  visitCount?: Maybe<Scalars['Int']>;
  visitorCount?: Maybe<Scalars['Int']>;
  waterAndSewage: WaterAndSewage;
};


export type PublicHomeImagesArgs = {
  input?: InputMaybe<InputPublicHomeImages>;
};


export type PublicHomeSimilarHomesArgs = {
  top?: InputMaybe<Scalars['Int']>;
};

export type PublicHomeFilter = {
  areaID?: InputMaybe<Scalars['ID']>;
  askingPriceRange?: InputMaybe<Range>;
  dateRange?: InputMaybe<HomeDateRangeFilter>;
  homeState?: InputMaybe<Array<HomeState>>;
  homeType?: InputMaybe<Array<HomeType>>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  livingAreaRange?: InputMaybe<Range>;
  random?: InputMaybe<Scalars['Boolean']>;
  roomsRange?: InputMaybe<Range>;
  showWithoutPrice?: InputMaybe<Scalars['Boolean']>;
  tenureType?: InputMaybe<Array<TenureType>>;
};

export type PublicHomeLikeness = {
  __typename?: 'PublicHomeLikeness';
  home: PublicHome;
  id: Scalars['ID'];
  similarHome: PublicHome;
  similarity: Scalars['Float'];
};

export type PublicHomesPaginatedEdge = {
  __typename?: 'PublicHomesPaginatedEdge';
  cursor: Scalars['String'];
  node: PublicHome;
};

export type PublicHomesPaginatedResult = {
  __typename?: 'PublicHomesPaginatedResult';
  edges: Array<PublicHomesPaginatedEdge>;
  pageInfo: PageInfo;
};

export type Query = {
  __typename?: 'Query';
  CRMActions: Array<CrmAction>;
  _empty?: Maybe<Scalars['String']>;
  area?: Maybe<Area>;
  areas: Array<Area>;
  bankidAuthenticateStatus: BankidStatusResponse;
  chatHandled: Scalars['Boolean'];
  chatMessage?: Maybe<ChatMessage>;
  chatMessages: Array<ChatMessage>;
  chatOwners: Array<ChatOwnership>;
  devices: Array<Device>;
  followerComment?: Maybe<FollowerComment>;
  followerCount?: Maybe<Scalars['Int']>;
  followers: Array<Follower>;
  geoJson: Scalars['String'];
  home: Home;
  homeRequests: Array<HomeRequest>;
  homes: Array<Home>;
  jobs: Array<Job>;
  lastRead?: Maybe<Scalars['DateTime']>;
  newConstructionHomes: Array<NewConstructionHome>;
  openMarketRedirects: Array<OpenMarketRedirect>;
  photoRequests: Array<HomeRequestPhotos>;
  publicFollowers: Array<PublicFollower>;
  publicHome?: Maybe<PublicHome>;
  publicHomeCount?: Maybe<Scalars['Int']>;
  publicHomeFromVitecId?: Maybe<PublicHome>;
  publicHomeMetricDistribution?: Maybe<HomeMetricDistribution>;
  publicHomes: Array<PublicHome>;
  publicHomesPaginated: PublicHomesPaginatedResult;
  rootAreas: Array<Area>;
  searches: Array<Search>;
  temporaryHousingEntries: Array<TemporaryHousingEntry>;
  timeline: Timeline;
  user: User;
  userAnalyticsEvents: Array<AggregatedEventDto>;
  userCount?: Maybe<Scalars['Int']>;
  userLabels: Array<UserLabel>;
  users: Array<User>;
  usersPaginated: UserPaginatedResult;
  valueGuardCredentials?: Maybe<ValueGuardCredentials>;
  versions: Versions;
};


export type QueryCrmActionsArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryAreaArgs = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};


export type QueryAreasArgs = {
  filter?: InputMaybe<AreaFilter>;
  rootOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryBankidAuthenticateStatusArgs = {
  sessionId: Scalars['String'];
};


export type QueryChatHandledArgs = {
  senderId: Scalars['ID'];
};


export type QueryChatMessageArgs = {
  chatMessageId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryChatMessagesArgs = {
  afterMessageId?: InputMaybe<Scalars['ID']>;
  markAsRead?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryChatOwnersArgs = {
  filter?: InputMaybe<ChatOwnershipFilter>;
};


export type QueryDevicesArgs = {
  filter?: InputMaybe<DevicesFilter>;
};


export type QueryFollowerCommentArgs = {
  email: Scalars['String'];
};


export type QueryFollowerCountArgs = {
  followerOptions?: InputMaybe<FollowerOptions>;
};


export type QueryFollowersArgs = {
  followerOptions?: InputMaybe<FollowerOptions>;
};


export type QueryHomeArgs = {
  id: Scalars['ID'];
};


export type QueryHomeRequestsArgs = {
  filter?: InputMaybe<FilterHomeRequests>;
};


export type QueryHomesArgs = {
  filter?: InputMaybe<HomeFilter>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryLastReadArgs = {
  userId: Scalars['ID'];
};


export type QueryNewConstructionHomesArgs = {
  homeId: Scalars['ID'];
};


export type QueryPhotoRequestsArgs = {
  homeId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryPublicFollowersArgs = {
  publicFollowerOptions?: InputMaybe<PublicFollowerOptions>;
};


export type QueryPublicHomeArgs = {
  id: Scalars['ID'];
  preview?: InputMaybe<Scalars['String']>;
  visitorId?: InputMaybe<Scalars['ID']>;
};


export type QueryPublicHomeFromVitecIdArgs = {
  vitecId: Scalars['ID'];
};


export type QueryPublicHomeMetricDistributionArgs = {
  bucketCount?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<PublicHomeFilter>;
};


export type QueryPublicHomesArgs = {
  filter?: InputMaybe<PublicHomeFilter>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryPublicHomesPaginatedArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<PublicHomeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAreasArgs = {
  filter?: InputMaybe<AreaFilter>;
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUserAnalyticsEventsArgs = {
  userId: Scalars['String'];
};


export type QueryUsersArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type QueryUsersPaginatedArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sortingFields?: Array<SortingFields>;
};

export type Range = {
  high?: InputMaybe<Scalars['Float']>;
  low?: InputMaybe<Scalars['Float']>;
};

export type Realtor = {
  __typename?: 'Realtor';
  email?: Maybe<Scalars['String']>;
  imageId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export enum Role {
  Admin = 'ADMIN',
  Anonymous = 'ANONYMOUS',
  Banned = 'BANNED',
  User = 'USER'
}

export type Room = {
  __typename?: 'Room';
  heading?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export enum RoomType {
  BalconyAndPatio = 'BALCONY_AND_PATIO',
  Bathroom = 'BATHROOM',
  Bedroom = 'BEDROOM',
  Kitchen = 'KITCHEN',
  LivingRoom = 'LIVING_ROOM',
  Misc = 'MISC'
}

export type Search = {
  __typename?: 'Search';
  areaIds: Array<Scalars['ID']>;
  areas: Array<Area>;
  createdAt: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  homeTypes: Array<HomeType>;
  id: Scalars['ID'];
  priceMax?: Maybe<Scalars['Float']>;
  priceMin?: Maybe<Scalars['Float']>;
  roomsMax?: Maybe<Scalars['Float']>;
  roomsMin?: Maybe<Scalars['Float']>;
  sizeMax?: Maybe<Scalars['Float']>;
  sizeMin?: Maybe<Scalars['Float']>;
  user?: Maybe<User>;
};

export type SearchInput = {
  areaIds?: InputMaybe<Array<Scalars['ID']>>;
  email?: InputMaybe<Scalars['String']>;
  homeTypes?: InputMaybe<Array<HomeType>>;
  priceMax?: InputMaybe<Scalars['Float']>;
  priceMin?: InputMaybe<Scalars['Float']>;
  roomsMax?: InputMaybe<Scalars['Float']>;
  roomsMin?: InputMaybe<Scalars['Float']>;
  sizeMax?: InputMaybe<Scalars['Float']>;
  sizeMin?: InputMaybe<Scalars['Float']>;
};

export type Session = {
  __typename?: 'Session';
  id: Scalars['ID'];
  privateUuid: Scalars['ID'];
  value: SessionValue;
};

export type SessionLoginEmailResult = {
  __typename?: 'SessionLoginEmailResult';
  emailChallengeAntiPhishingCode?: Maybe<Scalars['String']>;
  emailChallengeSent?: Maybe<Scalars['Boolean']>;
  newAccountCreated?: Maybe<Scalars['Boolean']>;
};

export type SessionMutationResult = {
  __typename?: 'SessionMutationResult';
  loginEmailResult?: Maybe<SessionLoginEmailResult>;
};

export enum SessionState {
  Anonymous = 'ANONYMOUS',
  Authenticated = 'AUTHENTICATED'
}

export type SessionValue = {
  __typename?: 'SessionValue';
  id: Scalars['ID'];
  jwt?: Maybe<Scalars['String']>;
  mutationResult?: Maybe<SessionMutationResult>;
  state: SessionState;
};

export enum ShowYourHomeRequest {
  All = 'ALL',
  Exterior = 'EXTERIOR',
  Floorplan = 'FLOORPLAN'
}

export enum SortingFields {
  ActiveScore = 'ACTIVE_SCORE',
  Id = 'ID',
  Name = 'NAME'
}

export type Subscription = {
  __typename?: 'Subscription';
  _empty?: Maybe<Scalars['String']>;
  chatMessageCreated: ChatMessage;
  homeUpdated: Home;
  logEntryCreated: LogEntry;
};


export type SubscriptionChatMessageCreatedArgs = {
  broadcast?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<Scalars['ID']>;
};


export type SubscriptionHomeUpdatedArgs = {
  userId: Scalars['ID'];
};


export type SubscriptionLogEntryCreatedArgs = {
  userId: Scalars['ID'];
};

export type Surrounding = {
  __typename?: 'Surrounding';
  communication?: Maybe<Scalars['String']>;
  general?: Maybe<Scalars['String']>;
  other?: Maybe<Scalars['String']>;
  parking?: Maybe<Scalars['String']>;
  services?: Maybe<Scalars['String']>;
};

export type SyncFollowerError = {
  __typename?: 'SyncFollowerError';
  id: Scalars['Int'];
  message: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  validationErrors?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type SyncFollowerErrors = {
  __typename?: 'SyncFollowerErrors';
  errors: Array<SyncFollowerError>;
};

export enum TagType {
  Attic = 'ATTIC',
  Balcony = 'BALCONY',
  Basement = 'BASEMENT',
  Bathtub = 'BATHTUB',
  BigBathroom = 'BIG_BATHROOM',
  BigKitchen = 'BIG_KITCHEN',
  Bright = 'BRIGHT',
  Carport = 'CARPORT',
  CeilingOrnament = 'CEILING_ORNAMENT',
  ChildFriendly = 'CHILD_FRIENDLY',
  Conservatory = 'CONSERVATORY',
  CornerPlot = 'CORNER_PLOT',
  Duplex = 'DUPLEX',
  Fireplace = 'FIREPLACE',
  FishboneFloor = 'FISHBONE_FLOOR',
  FloorHeating = 'FLOOR_HEATING',
  FrenchBalcony = 'FRENCH_BALCONY',
  Functionalism = 'FUNCTIONALISM',
  Garage = 'GARAGE',
  HighCeiling = 'HIGH_CEILING',
  InNeedOfRenovation = 'IN_NEED_OF_RENOVATION',
  Minimalistic = 'MINIMALISTIC',
  Modern = 'MODERN',
  NewlyBuiltHouse = 'NEWLY_BUILT_HOUSE',
  NewlyRenovated = 'NEWLY_RENOVATED',
  NineteenthCentury = 'NINETEENTH_CENTURY',
  OpenLayout = 'OPEN_LAYOUT',
  PanedWindows = 'PANED_WINDOWS',
  ParquetFloor = 'PARQUET_FLOOR',
  Pool = 'POOL',
  Retro = 'RETRO',
  Sauna = 'SAUNA',
  SeaView = 'SEA_VIEW',
  Secluded = 'SECLUDED',
  SingleStory = 'SINGLE_STORY',
  Spacious = 'SPACIOUS',
  Terrace = 'TERRACE',
  ThroughFloorPlan = 'THROUGH_FLOOR_PLAN',
  TiledStove = 'TILED_STOVE',
  Urban = 'URBAN',
  WoodenFloor = 'WOODEN_FLOOR'
}

export type Tags = {
  tags: Array<Scalars['String']>;
};

export type Task = {
  __typename?: 'Task';
  phase: PhaseType;
  state: TaskState;
  type: TaskType;
};

export type TaskInput = {
  phase?: InputMaybe<PhaseType>;
  state: TaskState;
  type: TaskType;
};

export enum TaskState {
  Available = 'AVAILABLE',
  Concluded = 'CONCLUDED',
  Locked = 'LOCKED',
  Pending = 'PENDING',
  Processed = 'PROCESSED'
}

export enum TaskType {
  AboutPremarket = 'ABOUT_PREMARKET',
  AboutSharingProfile = 'ABOUT_SHARING_PROFILE',
  AccessDay = 'ACCESS_DAY',
  AdIsOut = 'AD_IS_OUT',
  Biddings = 'BIDDINGS',
  BookPhotoShoot = 'BOOK_PHOTO_SHOOT',
  BookValuationMeeting = 'BOOK_VALUATION_MEETING',
  ContractMeeting = 'CONTRACT_MEETING',
  DepositAndBuyerApproval = 'DEPOSIT_AND_BUYER_APPROVAL',
  DescribeYourHome = 'DESCRIBE_YOUR_HOME',
  GoOpenMarket = 'GO_OPEN_MARKET',
  InformationForValuationMeeting = 'INFORMATION_FOR_VALUATION_MEETING',
  ItIsSold = 'IT_IS_SOLD',
  PhotoShoot = 'PHOTO_SHOOT',
  PutHomeOnMap = 'PUT_HOME_ON_MAP',
  ReadContract = 'READ_CONTRACT',
  ReviewPhotos = 'REVIEW_PHOTOS',
  ReviewPremarketAd = 'REVIEW_PREMARKET_AD',
  ReviewSettlement = 'REVIEW_SETTLEMENT',
  ShowYourHome = 'SHOW_YOUR_HOME',
  SignContract = 'SIGN_CONTRACT',
  Staging = 'STAGING',
  StartPreparing = 'START_PREPARING',
  TagYourHome = 'TAG_YOUR_HOME',
  ThinkingOfSelling = 'THINKING_OF_SELLING',
  ValuationMeeting = 'VALUATION_MEETING',
  ValuationMeetingSummary = 'VALUATION_MEETING_SUMMARY',
  Viewings = 'VIEWINGS'
}

export type TemporaryHousingEntry = {
  __typename?: 'TemporaryHousingEntry';
  city: Scalars['String'];
  email: Scalars['String'];
  endDate: Scalars['DateTime'];
  id?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  rooms: Scalars['Int'];
  startDate: Scalars['DateTime'];
};

export enum TenureType {
  Condominium = 'CONDOMINIUM',
  Cottage = 'COTTAGE',
  Freehold = 'FREEHOLD',
  GenericHouse = 'GENERIC_HOUSE',
  HousingCooperative = 'HOUSING_COOPERATIVE',
  Leasehold = 'LEASEHOLD',
  Project = 'PROJECT',
  ShareInHousingAssociation = 'SHARE_IN_HOUSING_ASSOCIATION'
}

export type Timeline = {
  __typename?: 'Timeline';
  currentTask?: Maybe<TaskType>;
  currentTaskState?: Maybe<TaskState>;
  pendingTasks: Array<TaskType>;
  tasks: Array<Task>;
};

export type TimelineInput = {
  tasks: Array<TaskInput>;
};

export type UndisclosedAddress = {
  __typename?: 'UndisclosedAddress';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
};

export type UndisclosedAddressInput = {
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateHomeInput = {
  userId: Scalars['ID'];
};

export type UpdateUserFileInput = {
  deleted?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type UpdatedCrmActionInput = {
  action?: InputMaybe<Scalars['String']>;
  target?: InputMaybe<Scalars['DateTime']>;
};

export type UpdatedFollowerInput = {
  active?: InputMaybe<Scalars['Boolean']>;
};

export type UpdatedUserInput = {
  bankInformation?: InputMaybe<BankInformationInput>;
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  home?: InputMaybe<HomeInput>;
  logEntry?: InputMaybe<LogEntryInput>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  personalIdentityNumber?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  photoURL?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Role>;
  unsubscribeFollowerMail?: InputMaybe<Scalars['Boolean']>;
  unsubscribeRecommendationMail?: InputMaybe<Scalars['Boolean']>;
  userLabels?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdatedUserInputOptions = {
  sendNotification?: InputMaybe<Scalars['Boolean']>;
};

export type UpdatedUserLabelInput = {
  label: Scalars['String'];
  teamsHook?: InputMaybe<Scalars['String']>;
};

export type UploadUserFileInput = {
  file: Scalars['Upload'];
  userId: Scalars['ID'];
};

export type User = {
  __typename?: 'User';
  CRMActions: Array<CrmAction>;
  activityScore: Scalars['Float'];
  bankInformation?: Maybe<BankInformation>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  files: Array<UserFile>;
  home?: Maybe<Home>;
  id?: Maybe<Scalars['ID']>;
  logEntries: Array<LogEntry>;
  logEntry?: Maybe<LogEntry>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  photoURL?: Maybe<Scalars['String']>;
  pin?: Maybe<Scalars['String']>;
  recommendations: Array<FollowerRecommendation>;
  role?: Maybe<Role>;
  unreadMessages?: Maybe<Scalars['Int']>;
  unsubscribeFollowerMail?: Maybe<Scalars['Boolean']>;
  unsubscribeRecommendationMail?: Maybe<Scalars['Boolean']>;
  userLabels: Array<Scalars['ID']>;
};


export type UserFilesArgs = {
  filter?: InputMaybe<UserFilesFilter>;
};


export type UserHomeArgs = {
  filter?: InputMaybe<HomeFilter>;
};


export type UserLogEntriesArgs = {
  options?: InputMaybe<LogEntryOptions>;
};


export type UserLogEntryArgs = {
  id: Scalars['ID'];
  options?: InputMaybe<LogEntryOptions>;
};

export type UserCrmActionsFilter = {
  end?: InputMaybe<Scalars['DateTime']>;
  inverted?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export type UserDataDto = {
  __typename?: 'UserDataDto';
  clientIpAddress?: Maybe<Scalars['String']>;
  clientUserAgent?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  homeId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserDateFilter = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type UserFile = {
  __typename?: 'UserFile';
  createdAt: Scalars['DateTime'];
  deleted: Scalars['Boolean'];
  filename: Scalars['String'];
  id: Scalars['ID'];
  mimetype: Scalars['String'];
  signedUrl: UserFilesignedUrl;
  updatedAt: Scalars['DateTime'];
};

export type UserFilesFilter = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type UserFilesignedUrl = {
  __typename?: 'UserFilesignedUrl';
  expiresAt: Scalars['DateTime'];
  url: Scalars['String'];
};

export type UserFilter = {
  CRMActions?: InputMaybe<UserCrmActionsFilter>;
  date?: InputMaybe<UserDateFilter>;
  followers?: InputMaybe<UserFollowersFilter>;
  haveDisplayName?: InputMaybe<Scalars['Boolean']>;
  haveHome?: InputMaybe<Scalars['Boolean']>;
  homeFilter?: InputMaybe<HomeFilter>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  searchQuery?: InputMaybe<Scalars['String']>;
  unreadMessages?: InputMaybe<UserMessagesFilter>;
  userLabels?: InputMaybe<UserLabelFilter>;
};

export type UserFollowersFilter = {
  end?: InputMaybe<Scalars['DateTime']>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export type UserLabel = {
  __typename?: 'UserLabel';
  id: Scalars['ID'];
  label: Scalars['String'];
  teamsHook?: Maybe<Scalars['String']>;
};

export type UserLabelFilter = {
  inverted?: InputMaybe<Scalars['Boolean']>;
  labels?: InputMaybe<Array<Scalars['ID']>>;
};

export type UserMessagesFilter = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  inverted?: InputMaybe<Scalars['Boolean']>;
};

export type UserPaginatedEdge = {
  __typename?: 'UserPaginatedEdge';
  cursor: Scalars['String'];
  node: User;
};

export type UserPaginatedResult = {
  __typename?: 'UserPaginatedResult';
  edges: Array<UserPaginatedEdge>;
  pageInfo: PageInfo;
};

export type ValuationMeetingInfo = {
  __typename?: 'ValuationMeetingInfo';
  buildingYear?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  entryCode?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['Int']>;
  location?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  ownership?: Maybe<Ownership>;
  participants?: Maybe<Scalars['String']>;
  renovations?: Maybe<Scalars['String']>;
  request?: Maybe<ValuationMeetingRequest>;
  result?: Maybe<Scalars['String']>;
  tenure?: Maybe<TenureType>;
};

export type ValuationMeetingInfoInput = {
  buildingYear?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  entryCode?: InputMaybe<Scalars['String']>;
  fee?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  ownership?: InputMaybe<OwnershipInput>;
  participants?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  renovations?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<ValuationMeetingRequest>;
  result?: InputMaybe<Scalars['String']>;
  tenure?: InputMaybe<TenureType>;
};

export enum ValuationMeetingRequest {
  Later = 'LATER',
  MoreInfo = 'MORE_INFO',
  Soon = 'SOON'
}

export type ValueGuardCredentials = {
  __typename?: 'ValueGuardCredentials';
  password: Scalars['String'];
  user: Scalars['String'];
};

export type Versions = {
  __typename?: 'Versions';
  minAppVersion: Scalars['String'];
};

export type Viewing = {
  __typename?: 'Viewing';
  endsAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  maxNbrOfParticipants?: Maybe<Scalars['Int']>;
  nbrOfBooked?: Maybe<Scalars['Int']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  timeSlots: Array<ViewingTimeSlot>;
  unspecifiedTime?: Maybe<Scalars['Boolean']>;
};

export type ViewingParticipantInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
};

export type ViewingTimeSlot = {
  __typename?: 'ViewingTimeSlot';
  endsAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  startsAt?: Maybe<Scalars['DateTime']>;
};

export type WaterAndSewage = {
  __typename?: 'WaterAndSewage';
  info?: Maybe<Scalars['String']>;
};

export type ObjektsbeskrivningHemInfoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ObjektsbeskrivningHemInfoQuery = { __typename?: 'Query', home: { __typename?: 'Home', id?: string | null, floor?: number | null, elevator?: boolean | null, balcony?: boolean | null, patio?: boolean | null, terrace?: boolean | null, monthlyFee?: number | null, monthlyFeeDescription?: string | null, askingPrice?: number | null, numberOfRooms?: number | null, livingArea?: number | null, otherArea?: number | null, state: HomeState, type?: HomeType | null, areaSource?: string | null, tenure?: TenureType | null, pawned?: boolean | null, description: { __typename?: 'Description', short?: string | null, other?: string | null }, address: { __typename?: 'Address', city?: string | null, municipality?: string | null, streetAddress?: string | null, zipCode?: string | null }, images: Array<{ __typename?: 'Image', id: string, isFloorPlan?: boolean | null }>, building: { __typename?: 'Building', floors?: number | null, year?: string | null, propertyDesignation?: string | null, type?: string | null, windows?: string | null, heating?: string | null, ventilation?: string | null, facade?: string | null, roof?: string | null, frame?: string | null, beam?: string | null, foundation?: string | null, foundationWall?: string | null, externalSheetMetalWork?: string | null }, area?: { __typename?: 'Area', name: string } | null, realtor?: { __typename?: 'Realtor', name?: string | null, phone?: string | null, email?: string | null, imageId?: string | null } | null, backup?: { __typename?: 'Realtor', name?: string | null, email?: string | null, phone?: string | null, imageId?: string | null } | null, operatingCost: { __typename?: 'OperatingCost', chimneySweeping?: number | null, commentary?: string | null, electricity?: number | null, heating?: number | null, insurance?: number | null, maintenance?: number | null, other?: number | null, residents?: number | null, roadCharge?: number | null, roadCommunity?: number | null, sanitation?: number | null, total?: number | null, waterAndSewage?: number | null }, rooms: Array<{ __typename?: 'Room', heading?: string | null, text?: string | null }>, association: { __typename?: 'Association', name?: string | null, generalDescription?: string | null, repairFund?: number | null, percentageOfAnnualFee?: number | null, percentageOfAssociation?: number | null, indirectNetDebt?: number | null, indirectNetDebtComment?: string | null }, energyDeclaration: { __typename?: 'EnergyDeclaration', date?: string | null, energyPerformance?: string | null, energyClass?: string | null }, plot: { __typename?: 'Plot', area?: number | null }, mortgages: Array<{ __typename?: 'Mortgage', amount?: number | null }>, assessment: { __typename?: 'Assessment', buildingValue?: number | null, fee?: number | null, landValue?: number | null, totalValue?: number | null, typeCode?: string | null, valueYear?: number | null, yearOfAssessment?: number | null }, leasehold: { __typename?: 'Leasehold', fee?: string | null, expiryDate?: any | null }, waterAndSewage: { __typename?: 'WaterAndSewage', info?: string | null } } };

export type SelectHomeAllHomesQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectHomeAllHomesQuery = { __typename?: 'Query', homes: Array<{ __typename?: 'Home', id?: string | null, address: { __typename?: 'Address', city?: string | null, streetAddress?: string | null } }> };

export type MapAllHomesQueryVariables = Exact<{ [key: string]: never; }>;


export type MapAllHomesQuery = { __typename?: 'Query', publicHomes: Array<{ __typename?: 'PublicHome', id: string, coordinate?: { __typename?: 'Coordinate', latitude?: number | null, longitude?: number | null } | null, undisclosedAddress?: { __typename?: 'UndisclosedAddress', latitude?: number | null, longitude?: number | null } | null }> };


export const ObjektsbeskrivningHemInfoDocument = gql`
    query ObjektsbeskrivningHemInfo($id: ID!) {
  home(id: $id) {
    id
    description {
      short
      other
    }
    address {
      city
      municipality
      streetAddress
      zipCode
    }
    images {
      id
      isFloorPlan
    }
    floor
    building {
      floors
    }
    elevator
    balcony
    patio
    terrace
    building {
      year
      propertyDesignation
    }
    monthlyFee
    monthlyFeeDescription
    askingPrice
    numberOfRooms
    livingArea
    otherArea
    state
    area {
      name
    }
    type
    realtor {
      name
      phone
      email
      imageId
    }
    backup {
      name
      email
      phone
      imageId
    }
    description {
      short
    }
    operatingCost {
      chimneySweeping
      commentary
      electricity
      heating
      insurance
      maintenance
      other
      residents
      roadCharge
      roadCommunity
      sanitation
      total
      waterAndSewage
    }
    rooms {
      heading
      text
    }
    association {
      name
      generalDescription
      repairFund
      percentageOfAnnualFee
      percentageOfAssociation
      indirectNetDebt
      indirectNetDebtComment
    }
    energyDeclaration {
      date
      energyPerformance
      energyClass
    }
    areaSource
    tenure
    pawned
    plot {
      area
    }
    mortgages {
      amount
    }
    assessment {
      buildingValue
      fee
      landValue
      totalValue
      typeCode
      valueYear
      yearOfAssessment
    }
    leasehold {
      fee
      expiryDate
    }
    building {
      type
      windows
      heating
      ventilation
      facade
      roof
      frame
      beam
      foundation
      foundationWall
      externalSheetMetalWork
    }
    waterAndSewage {
      info
    }
  }
}
    `;

/**
 * __useObjektsbeskrivningHemInfoQuery__
 *
 * To run a query within a React component, call `useObjektsbeskrivningHemInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useObjektsbeskrivningHemInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObjektsbeskrivningHemInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useObjektsbeskrivningHemInfoQuery(baseOptions: Apollo.QueryHookOptions<ObjektsbeskrivningHemInfoQuery, ObjektsbeskrivningHemInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ObjektsbeskrivningHemInfoQuery, ObjektsbeskrivningHemInfoQueryVariables>(ObjektsbeskrivningHemInfoDocument, options);
      }
export function useObjektsbeskrivningHemInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ObjektsbeskrivningHemInfoQuery, ObjektsbeskrivningHemInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ObjektsbeskrivningHemInfoQuery, ObjektsbeskrivningHemInfoQueryVariables>(ObjektsbeskrivningHemInfoDocument, options);
        }
export type ObjektsbeskrivningHemInfoQueryHookResult = ReturnType<typeof useObjektsbeskrivningHemInfoQuery>;
export type ObjektsbeskrivningHemInfoLazyQueryHookResult = ReturnType<typeof useObjektsbeskrivningHemInfoLazyQuery>;
export type ObjektsbeskrivningHemInfoQueryResult = Apollo.QueryResult<ObjektsbeskrivningHemInfoQuery, ObjektsbeskrivningHemInfoQueryVariables>;
export const SelectHomeAllHomesDocument = gql`
    query SelectHomeAllHomes {
  homes(filter: {homeStates: [PREMARKET, OPEN_MARKET]}) {
    id
    address {
      city
      streetAddress
    }
  }
}
    `;

/**
 * __useSelectHomeAllHomesQuery__
 *
 * To run a query within a React component, call `useSelectHomeAllHomesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectHomeAllHomesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectHomeAllHomesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectHomeAllHomesQuery(baseOptions?: Apollo.QueryHookOptions<SelectHomeAllHomesQuery, SelectHomeAllHomesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectHomeAllHomesQuery, SelectHomeAllHomesQueryVariables>(SelectHomeAllHomesDocument, options);
      }
export function useSelectHomeAllHomesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectHomeAllHomesQuery, SelectHomeAllHomesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectHomeAllHomesQuery, SelectHomeAllHomesQueryVariables>(SelectHomeAllHomesDocument, options);
        }
export type SelectHomeAllHomesQueryHookResult = ReturnType<typeof useSelectHomeAllHomesQuery>;
export type SelectHomeAllHomesLazyQueryHookResult = ReturnType<typeof useSelectHomeAllHomesLazyQuery>;
export type SelectHomeAllHomesQueryResult = Apollo.QueryResult<SelectHomeAllHomesQuery, SelectHomeAllHomesQueryVariables>;
export const MapAllHomesDocument = gql`
    query MapAllHomes {
  publicHomes(filter: {homeState: [PREMARKET_LIGHT, PREMARKET, OPEN_MARKET]}) {
    id
    coordinate {
      latitude
      longitude
    }
    undisclosedAddress {
      latitude
      longitude
    }
  }
}
    `;

/**
 * __useMapAllHomesQuery__
 *
 * To run a query within a React component, call `useMapAllHomesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMapAllHomesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMapAllHomesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMapAllHomesQuery(baseOptions?: Apollo.QueryHookOptions<MapAllHomesQuery, MapAllHomesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MapAllHomesQuery, MapAllHomesQueryVariables>(MapAllHomesDocument, options);
      }
export function useMapAllHomesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MapAllHomesQuery, MapAllHomesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MapAllHomesQuery, MapAllHomesQueryVariables>(MapAllHomesDocument, options);
        }
export type MapAllHomesQueryHookResult = ReturnType<typeof useMapAllHomesQuery>;
export type MapAllHomesLazyQueryHookResult = ReturnType<typeof useMapAllHomesLazyQuery>;
export type MapAllHomesQueryResult = Apollo.QueryResult<MapAllHomesQuery, MapAllHomesQueryVariables>;
export type AccessMeetingKeySpecifier = ('date' | 'location' | AccessMeetingKeySpecifier)[];
export type AccessMeetingFieldPolicy = {
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddressKeySpecifier = ('city' | 'municipality' | 'streetAddress' | 'streetName' | 'zipCode' | AddressKeySpecifier)[];
export type AddressFieldPolicy = {
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	municipality?: FieldPolicy<any> | FieldReadFunction<any>,
	streetAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	streetName?: FieldPolicy<any> | FieldReadFunction<any>,
	zipCode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AggregatedEventDtoKeySpecifier = ('date' | 'deviceData' | 'event' | 'eventType' | 'id' | 'page' | 'screen' | 'userData' | AggregatedEventDtoKeySpecifier)[];
export type AggregatedEventDtoFieldPolicy = {
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceData?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	eventType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	screen?: FieldPolicy<any> | FieldReadFunction<any>,
	userData?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AreaKeySpecifier = ('bounds' | 'children' | 'homeCount' | 'homes' | 'id' | 'name' | 'parent' | 'parentId' | 'polygon' | 'public' | 'root' | 'rootId' | AreaKeySpecifier)[];
export type AreaFieldPolicy = {
	bounds?: FieldPolicy<any> | FieldReadFunction<any>,
	children?: FieldPolicy<any> | FieldReadFunction<any>,
	homeCount?: FieldPolicy<any> | FieldReadFunction<any>,
	homes?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	parent?: FieldPolicy<any> | FieldReadFunction<any>,
	parentId?: FieldPolicy<any> | FieldReadFunction<any>,
	polygon?: FieldPolicy<any> | FieldReadFunction<any>,
	public?: FieldPolicy<any> | FieldReadFunction<any>,
	root?: FieldPolicy<any> | FieldReadFunction<any>,
	rootId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssessmentKeySpecifier = ('buildingValue' | 'fee' | 'landValue' | 'totalValue' | 'typeCode' | 'valueYear' | 'yearOfAssessment' | AssessmentKeySpecifier)[];
export type AssessmentFieldPolicy = {
	buildingValue?: FieldPolicy<any> | FieldReadFunction<any>,
	fee?: FieldPolicy<any> | FieldReadFunction<any>,
	landValue?: FieldPolicy<any> | FieldReadFunction<any>,
	totalValue?: FieldPolicy<any> | FieldReadFunction<any>,
	typeCode?: FieldPolicy<any> | FieldReadFunction<any>,
	valueYear?: FieldPolicy<any> | FieldReadFunction<any>,
	yearOfAssessment?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssociationKeySpecifier = ('generalDescription' | 'indirectNetDebt' | 'indirectNetDebtComment' | 'name' | 'percentageOfAnnualFee' | 'percentageOfAssociation' | 'repairFund' | AssociationKeySpecifier)[];
export type AssociationFieldPolicy = {
	generalDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	indirectNetDebt?: FieldPolicy<any> | FieldReadFunction<any>,
	indirectNetDebtComment?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	percentageOfAnnualFee?: FieldPolicy<any> | FieldReadFunction<any>,
	percentageOfAssociation?: FieldPolicy<any> | FieldReadFunction<any>,
	repairFund?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BankInformationKeySpecifier = ('accountNumber' | 'clearingNumber' | 'name' | BankInformationKeySpecifier)[];
export type BankInformationFieldPolicy = {
	accountNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	clearingNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BankidInitResponseKeySpecifier = ('autoStartToken' | 'errorCode' | 'sessionId' | 'success' | BankidInitResponseKeySpecifier)[];
export type BankidInitResponseFieldPolicy = {
	autoStartToken?: FieldPolicy<any> | FieldReadFunction<any>,
	errorCode?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionId?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BankidStatusResponseKeySpecifier = ('errorCode' | 'jwt' | 'success' | 'user' | BankidStatusResponseKeySpecifier)[];
export type BankidStatusResponseFieldPolicy = {
	errorCode?: FieldPolicy<any> | FieldReadFunction<any>,
	jwt?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BankidUserKeySpecifier = ('givenName' | 'name' | 'personalNumber' | 'surname' | BankidUserKeySpecifier)[];
export type BankidUserFieldPolicy = {
	givenName?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	personalNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	surname?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BidKeySpecifier = ('amount' | 'bidderAlias' | 'createdAt' | 'id' | 'isCanceled' | 'stopped' | BidKeySpecifier)[];
export type BidFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	bidderAlias?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isCanceled?: FieldPolicy<any> | FieldReadFunction<any>,
	stopped?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BoundsKeySpecifier = ('max' | 'min' | BoundsKeySpecifier)[];
export type BoundsFieldPolicy = {
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BuildingKeySpecifier = ('beam' | 'externalSheetMetalWork' | 'facade' | 'floors' | 'foundation' | 'foundationWall' | 'frame' | 'heating' | 'newConstruction' | 'otherBuildings' | 'propertyDesignation' | 'renovations' | 'roof' | 'type' | 'ventilation' | 'windows' | 'year' | BuildingKeySpecifier)[];
export type BuildingFieldPolicy = {
	beam?: FieldPolicy<any> | FieldReadFunction<any>,
	externalSheetMetalWork?: FieldPolicy<any> | FieldReadFunction<any>,
	facade?: FieldPolicy<any> | FieldReadFunction<any>,
	floors?: FieldPolicy<any> | FieldReadFunction<any>,
	foundation?: FieldPolicy<any> | FieldReadFunction<any>,
	foundationWall?: FieldPolicy<any> | FieldReadFunction<any>,
	frame?: FieldPolicy<any> | FieldReadFunction<any>,
	heating?: FieldPolicy<any> | FieldReadFunction<any>,
	newConstruction?: FieldPolicy<any> | FieldReadFunction<any>,
	otherBuildings?: FieldPolicy<any> | FieldReadFunction<any>,
	propertyDesignation?: FieldPolicy<any> | FieldReadFunction<any>,
	renovations?: FieldPolicy<any> | FieldReadFunction<any>,
	roof?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	ventilation?: FieldPolicy<any> | FieldReadFunction<any>,
	windows?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CRMActionKeySpecifier = ('action' | 'id' | 'target' | CRMActionKeySpecifier)[];
export type CRMActionFieldPolicy = {
	action?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	target?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChatMessageKeySpecifier = ('id' | 'message' | 'recipient' | 'sender' | 'timestamp' | ChatMessageKeySpecifier)[];
export type ChatMessageFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	sender?: FieldPolicy<any> | FieldReadFunction<any>,
	timestamp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChatOwnershipKeySpecifier = ('handled' | 'homeId' | 'name' | 'ownerId' | 'streetAddress' | 'userId' | ChatOwnershipKeySpecifier)[];
export type ChatOwnershipFieldPolicy = {
	handled?: FieldPolicy<any> | FieldReadFunction<any>,
	homeId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerId?: FieldPolicy<any> | FieldReadFunction<any>,
	streetAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContractMeetingKeySpecifier = ('date' | 'location' | ContractMeetingKeySpecifier)[];
export type ContractMeetingFieldPolicy = {
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CoordinateKeySpecifier = ('latitude' | 'longitude' | CoordinateKeySpecifier)[];
export type CoordinateFieldPolicy = {
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DescriptionKeySpecifier = ('other' | 'short' | DescriptionKeySpecifier)[];
export type DescriptionFieldPolicy = {
	other?: FieldPolicy<any> | FieldReadFunction<any>,
	short?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeviceKeySpecifier = ('fcmToken' | 'notificationsPermission' | 'updatedAt' | 'userId' | DeviceKeySpecifier)[];
export type DeviceFieldPolicy = {
	fcmToken?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationsPermission?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeviceDataDtoKeySpecifier = ('platformOs' | 'platformVersion' | 'screenHeight' | 'screenWidth' | DeviceDataDtoKeySpecifier)[];
export type DeviceDataDtoFieldPolicy = {
	platformOs?: FieldPolicy<any> | FieldReadFunction<any>,
	platformVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	screenHeight?: FieldPolicy<any> | FieldReadFunction<any>,
	screenWidth?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DistributionKeySpecifier = ('distribution' | 'max' | 'min' | DistributionKeySpecifier)[];
export type DistributionFieldPolicy = {
	distribution?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DocumentKeySpecifier = ('category' | 'extension' | 'id' | 'name' | DocumentKeySpecifier)[];
export type DocumentFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	extension?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmailKeySpecifier = ('email' | EmailKeySpecifier)[];
export type EmailFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnergyDeclarationKeySpecifier = ('completed' | 'consumption' | 'date' | 'energyClass' | 'energyPerformance' | EnergyDeclarationKeySpecifier)[];
export type EnergyDeclarationFieldPolicy = {
	completed?: FieldPolicy<any> | FieldReadFunction<any>,
	consumption?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	energyClass?: FieldPolicy<any> | FieldReadFunction<any>,
	energyPerformance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FollowerKeySpecifier = ('active' | 'activeToggledAt' | 'createdAt' | 'email' | 'homeId' | 'id' | 'name' | 'phone' | 'publicHome' | 'updatedAt' | 'user' | 'userId' | FollowerKeySpecifier)[];
export type FollowerFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	activeToggledAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	homeId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	publicHome?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FollowerCommentKeySpecifier = ('comment' | FollowerCommentKeySpecifier)[];
export type FollowerCommentFieldPolicy = {
	comment?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FollowerRecommendationKeySpecifier = ('createdAt' | 'id' | 'publicHome' | 'user' | FollowerRecommendationKeySpecifier)[];
export type FollowerRecommendationFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	publicHome?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HomeKeySpecifier = ('accessMeeting' | 'adApproved' | 'adHideArea' | 'adHideCommission' | 'adPreviewUrl' | 'adUrl' | 'additionalSpace' | 'address' | 'area' | 'areaId' | 'areaSource' | 'askingPrice' | 'askingPriceMax' | 'assessment' | 'association' | 'backup' | 'backupId' | 'balcony' | 'bankAccountNumber' | 'biddingState' | 'biddingUrl' | 'building' | 'buildingYear' | 'client' | 'closingPrice' | 'contractDate' | 'contractMeeting' | 'contract_read' | 'coordinate' | 'created' | 'description' | 'descriptionOther' | 'descriptionShort' | 'descriptiveLines' | 'documents' | 'elevator' | 'energyDeclaration' | 'floor' | 'floorMax' | 'followerCount' | 'followers' | 'id' | 'images' | 'insurance' | 'leasehold' | 'livingArea' | 'livingAreaMax' | 'logEntries' | 'marketingDescription' | 'marketingEnabled' | 'marketingTitle' | 'monthlyFee' | 'monthlyFeeDescription' | 'monthlyFeeMax' | 'mortgages' | 'newConstructionAvailable' | 'newConstructionCount' | 'newConstructionEstCompletionDate' | 'newConstructionHome' | 'newConstructionHouseView' | 'newConstructionProjectName' | 'newConstructionSubTenure' | 'notes' | 'numberOfRooms' | 'numberOfRoomsMax' | 'openMarket' | 'operatingCost' | 'otherArea' | 'patio' | 'pawned' | 'photoShoot' | 'photosApproved' | 'plot' | 'preferentialAndCommunityEnrollments' | 'publishingDate' | 'realtor' | 'realtorId' | 'requests' | 'rooms' | 'rootArea' | 'sellingEstimate' | 'settlement_reviewed' | 'showYourHomePreference' | 'sortingTimestamp' | 'state' | 'stateChanged' | 'surrounding' | 'tags' | 'tenure' | 'terrace' | 'timeline' | 'type' | 'undisclosedAddress' | 'urlExtension' | 'user' | 'userId' | 'valuationMeeting' | 'viewings' | 'viewingsSummary' | 'visitCount' | 'visitorCount' | 'vitecEstateId' | 'waterAndSewage' | HomeKeySpecifier)[];
export type HomeFieldPolicy = {
	accessMeeting?: FieldPolicy<any> | FieldReadFunction<any>,
	adApproved?: FieldPolicy<any> | FieldReadFunction<any>,
	adHideArea?: FieldPolicy<any> | FieldReadFunction<any>,
	adHideCommission?: FieldPolicy<any> | FieldReadFunction<any>,
	adPreviewUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	adUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	additionalSpace?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	area?: FieldPolicy<any> | FieldReadFunction<any>,
	areaId?: FieldPolicy<any> | FieldReadFunction<any>,
	areaSource?: FieldPolicy<any> | FieldReadFunction<any>,
	askingPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	askingPriceMax?: FieldPolicy<any> | FieldReadFunction<any>,
	assessment?: FieldPolicy<any> | FieldReadFunction<any>,
	association?: FieldPolicy<any> | FieldReadFunction<any>,
	backup?: FieldPolicy<any> | FieldReadFunction<any>,
	backupId?: FieldPolicy<any> | FieldReadFunction<any>,
	balcony?: FieldPolicy<any> | FieldReadFunction<any>,
	bankAccountNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	biddingState?: FieldPolicy<any> | FieldReadFunction<any>,
	biddingUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	building?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingYear?: FieldPolicy<any> | FieldReadFunction<any>,
	client?: FieldPolicy<any> | FieldReadFunction<any>,
	closingPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	contractDate?: FieldPolicy<any> | FieldReadFunction<any>,
	contractMeeting?: FieldPolicy<any> | FieldReadFunction<any>,
	contract_read?: FieldPolicy<any> | FieldReadFunction<any>,
	coordinate?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionOther?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionShort?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptiveLines?: FieldPolicy<any> | FieldReadFunction<any>,
	documents?: FieldPolicy<any> | FieldReadFunction<any>,
	elevator?: FieldPolicy<any> | FieldReadFunction<any>,
	energyDeclaration?: FieldPolicy<any> | FieldReadFunction<any>,
	floor?: FieldPolicy<any> | FieldReadFunction<any>,
	floorMax?: FieldPolicy<any> | FieldReadFunction<any>,
	followerCount?: FieldPolicy<any> | FieldReadFunction<any>,
	followers?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	images?: FieldPolicy<any> | FieldReadFunction<any>,
	insurance?: FieldPolicy<any> | FieldReadFunction<any>,
	leasehold?: FieldPolicy<any> | FieldReadFunction<any>,
	livingArea?: FieldPolicy<any> | FieldReadFunction<any>,
	livingAreaMax?: FieldPolicy<any> | FieldReadFunction<any>,
	logEntries?: FieldPolicy<any> | FieldReadFunction<any>,
	marketingDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	marketingEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	marketingTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	monthlyFee?: FieldPolicy<any> | FieldReadFunction<any>,
	monthlyFeeDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	monthlyFeeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	mortgages?: FieldPolicy<any> | FieldReadFunction<any>,
	newConstructionAvailable?: FieldPolicy<any> | FieldReadFunction<any>,
	newConstructionCount?: FieldPolicy<any> | FieldReadFunction<any>,
	newConstructionEstCompletionDate?: FieldPolicy<any> | FieldReadFunction<any>,
	newConstructionHome?: FieldPolicy<any> | FieldReadFunction<any>,
	newConstructionHouseView?: FieldPolicy<any> | FieldReadFunction<any>,
	newConstructionProjectName?: FieldPolicy<any> | FieldReadFunction<any>,
	newConstructionSubTenure?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfRooms?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfRoomsMax?: FieldPolicy<any> | FieldReadFunction<any>,
	openMarket?: FieldPolicy<any> | FieldReadFunction<any>,
	operatingCost?: FieldPolicy<any> | FieldReadFunction<any>,
	otherArea?: FieldPolicy<any> | FieldReadFunction<any>,
	patio?: FieldPolicy<any> | FieldReadFunction<any>,
	pawned?: FieldPolicy<any> | FieldReadFunction<any>,
	photoShoot?: FieldPolicy<any> | FieldReadFunction<any>,
	photosApproved?: FieldPolicy<any> | FieldReadFunction<any>,
	plot?: FieldPolicy<any> | FieldReadFunction<any>,
	preferentialAndCommunityEnrollments?: FieldPolicy<any> | FieldReadFunction<any>,
	publishingDate?: FieldPolicy<any> | FieldReadFunction<any>,
	realtor?: FieldPolicy<any> | FieldReadFunction<any>,
	realtorId?: FieldPolicy<any> | FieldReadFunction<any>,
	requests?: FieldPolicy<any> | FieldReadFunction<any>,
	rooms?: FieldPolicy<any> | FieldReadFunction<any>,
	rootArea?: FieldPolicy<any> | FieldReadFunction<any>,
	sellingEstimate?: FieldPolicy<any> | FieldReadFunction<any>,
	settlement_reviewed?: FieldPolicy<any> | FieldReadFunction<any>,
	showYourHomePreference?: FieldPolicy<any> | FieldReadFunction<any>,
	sortingTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	stateChanged?: FieldPolicy<any> | FieldReadFunction<any>,
	surrounding?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	tenure?: FieldPolicy<any> | FieldReadFunction<any>,
	terrace?: FieldPolicy<any> | FieldReadFunction<any>,
	timeline?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	undisclosedAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	urlExtension?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>,
	valuationMeeting?: FieldPolicy<any> | FieldReadFunction<any>,
	viewings?: FieldPolicy<any> | FieldReadFunction<any>,
	viewingsSummary?: FieldPolicy<any> | FieldReadFunction<any>,
	visitCount?: FieldPolicy<any> | FieldReadFunction<any>,
	visitorCount?: FieldPolicy<any> | FieldReadFunction<any>,
	vitecEstateId?: FieldPolicy<any> | FieldReadFunction<any>,
	waterAndSewage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HomeLogEntryKeySpecifier = ('id' | 'message' | 'timestamp' | HomeLogEntryKeySpecifier)[];
export type HomeLogEntryFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	timestamp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HomeMetricDistributionKeySpecifier = ('askingPrice' | 'count' | 'livingArea' | 'rooms' | HomeMetricDistributionKeySpecifier)[];
export type HomeMetricDistributionFieldPolicy = {
	askingPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	livingArea?: FieldPolicy<any> | FieldReadFunction<any>,
	rooms?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HomeRequestKeySpecifier = ('createdAt' | 'homeId' | 'requestType' | 'userId' | HomeRequestKeySpecifier)[];
export type HomeRequestFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	homeId?: FieldPolicy<any> | FieldReadFunction<any>,
	requestType?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HomeRequestPhotosKeySpecifier = ('count' | 'createdAt' | 'homeId' | HomeRequestPhotosKeySpecifier)[];
export type HomeRequestPhotosFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	homeId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HomesKeySpecifier = ('homes' | HomesKeySpecifier)[];
export type HomesFieldPolicy = {
	homes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImageKeySpecifier = ('id' | 'isFloorPlan' | ImageKeySpecifier)[];
export type ImageFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isFloorPlan?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InsuranceKeySpecifier = ('amount' | 'company' | 'fullValue' | InsuranceKeySpecifier)[];
export type InsuranceFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	company?: FieldPolicy<any> | FieldReadFunction<any>,
	fullValue?: FieldPolicy<any> | FieldReadFunction<any>
};
export type JobKeySpecifier = ('id' | 'state' | JobKeySpecifier)[];
export type JobFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LeaseholdKeySpecifier = ('expiryDate' | 'fee' | LeaseholdKeySpecifier)[];
export type LeaseholdFieldPolicy = {
	expiryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	fee?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LogEntryKeySpecifier = ('id' | 'message' | 'meta' | 'originator' | 'timestamp' | 'type' | LogEntryKeySpecifier)[];
export type LogEntryFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	originator?: FieldPolicy<any> | FieldReadFunction<any>,
	timestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MortgageKeySpecifier = ('amount' | MortgageKeySpecifier)[];
export type MortgageFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationKeySpecifier = ('_empty' | 'addDevice' | 'addViewingParticipant' | 'approvePhotos' | 'approvePremarketAd' | 'assignmentContractSent' | 'banUser' | 'bankidAuthenticateInit' | 'bookPhotoShoot' | 'bookValuationMeeting' | 'bumpHome' | 'callMe' | 'chatAdminister' | 'contractSigned' | 'createCRMAction' | 'createHomeRequest' | 'createNewConstructionHome' | 'createOpenMarketRedirect' | 'createOpportunity' | 'createTemporaryHousing' | 'createUser' | 'createUserLabel' | 'deleteAccount' | 'deleteArea' | 'deleteCRMAction' | 'deleteDevice' | 'deleteFollower' | 'deleteHomeOwner' | 'deleteLogEntry' | 'deleteNewConstructionHome' | 'deleteOpenMarketRedirect' | 'deleteOpportunity' | 'deleteSearch' | 'deleteUser' | 'deleteUserLabel' | 'describeHome' | 'flushVitec' | 'followHome' | 'heldPhotoShoot' | 'heldStaging' | 'heldValuationMeeting' | 'informationForValuationMeeting' | 'initiatePasswordReset' | 'login' | 'makePhotosAvailable' | 'makePremarketAdAvailable' | 'markAllChatAsRead' | 'markChatAsHandled' | 'newArea' | 'onboard' | 'planForOpenMarket' | 'read' | 'readContract' | 'requestInformationForValuationMeeting' | 'requestPhotos' | 'resetPassword' | 'reviewedSettlement' | 'saveSearch' | 'sendChatMessage' | 'sendChatReminder' | 'sendDescriptiveLines' | 'session' | 'sessionRespondLoginChallenge' | 'setBankInformation' | 'setPhotoShoot' | 'setStaging' | 'setValuationMeeting' | 'showYourHome' | 'syncFollower' | 'syncImages' | 'updateArea' | 'updateCRMAction' | 'updateDevice' | 'updateFollower' | 'updateFollowerComment' | 'updateGeoJson' | 'updateHome' | 'updateNewConstructionHome' | 'updateOpenMarketRedirect' | 'updateOpportunity' | 'updateTaskState' | 'updateUser' | 'updateUserFile' | 'updateUserLabel' | 'uploadUserFile' | 'valuationMeetingSummaryRead' | MutationKeySpecifier)[];
export type MutationFieldPolicy = {
	_empty?: FieldPolicy<any> | FieldReadFunction<any>,
	addDevice?: FieldPolicy<any> | FieldReadFunction<any>,
	addViewingParticipant?: FieldPolicy<any> | FieldReadFunction<any>,
	approvePhotos?: FieldPolicy<any> | FieldReadFunction<any>,
	approvePremarketAd?: FieldPolicy<any> | FieldReadFunction<any>,
	assignmentContractSent?: FieldPolicy<any> | FieldReadFunction<any>,
	banUser?: FieldPolicy<any> | FieldReadFunction<any>,
	bankidAuthenticateInit?: FieldPolicy<any> | FieldReadFunction<any>,
	bookPhotoShoot?: FieldPolicy<any> | FieldReadFunction<any>,
	bookValuationMeeting?: FieldPolicy<any> | FieldReadFunction<any>,
	bumpHome?: FieldPolicy<any> | FieldReadFunction<any>,
	callMe?: FieldPolicy<any> | FieldReadFunction<any>,
	chatAdminister?: FieldPolicy<any> | FieldReadFunction<any>,
	contractSigned?: FieldPolicy<any> | FieldReadFunction<any>,
	createCRMAction?: FieldPolicy<any> | FieldReadFunction<any>,
	createHomeRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	createNewConstructionHome?: FieldPolicy<any> | FieldReadFunction<any>,
	createOpenMarketRedirect?: FieldPolicy<any> | FieldReadFunction<any>,
	createOpportunity?: FieldPolicy<any> | FieldReadFunction<any>,
	createTemporaryHousing?: FieldPolicy<any> | FieldReadFunction<any>,
	createUser?: FieldPolicy<any> | FieldReadFunction<any>,
	createUserLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteArea?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCRMAction?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDevice?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteFollower?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteHomeOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteLogEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteNewConstructionHome?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteOpenMarketRedirect?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteOpportunity?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteSearch?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteUser?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteUserLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	describeHome?: FieldPolicy<any> | FieldReadFunction<any>,
	flushVitec?: FieldPolicy<any> | FieldReadFunction<any>,
	followHome?: FieldPolicy<any> | FieldReadFunction<any>,
	heldPhotoShoot?: FieldPolicy<any> | FieldReadFunction<any>,
	heldStaging?: FieldPolicy<any> | FieldReadFunction<any>,
	heldValuationMeeting?: FieldPolicy<any> | FieldReadFunction<any>,
	informationForValuationMeeting?: FieldPolicy<any> | FieldReadFunction<any>,
	initiatePasswordReset?: FieldPolicy<any> | FieldReadFunction<any>,
	login?: FieldPolicy<any> | FieldReadFunction<any>,
	makePhotosAvailable?: FieldPolicy<any> | FieldReadFunction<any>,
	makePremarketAdAvailable?: FieldPolicy<any> | FieldReadFunction<any>,
	markAllChatAsRead?: FieldPolicy<any> | FieldReadFunction<any>,
	markChatAsHandled?: FieldPolicy<any> | FieldReadFunction<any>,
	newArea?: FieldPolicy<any> | FieldReadFunction<any>,
	onboard?: FieldPolicy<any> | FieldReadFunction<any>,
	planForOpenMarket?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	readContract?: FieldPolicy<any> | FieldReadFunction<any>,
	requestInformationForValuationMeeting?: FieldPolicy<any> | FieldReadFunction<any>,
	requestPhotos?: FieldPolicy<any> | FieldReadFunction<any>,
	resetPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	reviewedSettlement?: FieldPolicy<any> | FieldReadFunction<any>,
	saveSearch?: FieldPolicy<any> | FieldReadFunction<any>,
	sendChatMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	sendChatReminder?: FieldPolicy<any> | FieldReadFunction<any>,
	sendDescriptiveLines?: FieldPolicy<any> | FieldReadFunction<any>,
	session?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionRespondLoginChallenge?: FieldPolicy<any> | FieldReadFunction<any>,
	setBankInformation?: FieldPolicy<any> | FieldReadFunction<any>,
	setPhotoShoot?: FieldPolicy<any> | FieldReadFunction<any>,
	setStaging?: FieldPolicy<any> | FieldReadFunction<any>,
	setValuationMeeting?: FieldPolicy<any> | FieldReadFunction<any>,
	showYourHome?: FieldPolicy<any> | FieldReadFunction<any>,
	syncFollower?: FieldPolicy<any> | FieldReadFunction<any>,
	syncImages?: FieldPolicy<any> | FieldReadFunction<any>,
	updateArea?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCRMAction?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDevice?: FieldPolicy<any> | FieldReadFunction<any>,
	updateFollower?: FieldPolicy<any> | FieldReadFunction<any>,
	updateFollowerComment?: FieldPolicy<any> | FieldReadFunction<any>,
	updateGeoJson?: FieldPolicy<any> | FieldReadFunction<any>,
	updateHome?: FieldPolicy<any> | FieldReadFunction<any>,
	updateNewConstructionHome?: FieldPolicy<any> | FieldReadFunction<any>,
	updateOpenMarketRedirect?: FieldPolicy<any> | FieldReadFunction<any>,
	updateOpportunity?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTaskState?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUser?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUserFile?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUserLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadUserFile?: FieldPolicy<any> | FieldReadFunction<any>,
	valuationMeetingSummaryRead?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NewConstructionHomeKeySpecifier = ('home' | 'homeId' | 'id' | 'linkedHomeId' | 'name' | 'state' | NewConstructionHomeKeySpecifier)[];
export type NewConstructionHomeFieldPolicy = {
	home?: FieldPolicy<any> | FieldReadFunction<any>,
	homeId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedHomeId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OpenMarketKeySpecifier = ('request' | OpenMarketKeySpecifier)[];
export type OpenMarketFieldPolicy = {
	request?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OpenMarketRedirectKeySpecifier = ('id' | 'identifier' | 'url' | OpenMarketRedirectKeySpecifier)[];
export type OpenMarketRedirectFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	identifier?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OperatingCostKeySpecifier = ('chimneySweeping' | 'commentary' | 'electricity' | 'heating' | 'insurance' | 'maintenance' | 'other' | 'residents' | 'roadCharge' | 'roadCommunity' | 'sanitation' | 'total' | 'waterAndSewage' | OperatingCostKeySpecifier)[];
export type OperatingCostFieldPolicy = {
	chimneySweeping?: FieldPolicy<any> | FieldReadFunction<any>,
	commentary?: FieldPolicy<any> | FieldReadFunction<any>,
	electricity?: FieldPolicy<any> | FieldReadFunction<any>,
	heating?: FieldPolicy<any> | FieldReadFunction<any>,
	insurance?: FieldPolicy<any> | FieldReadFunction<any>,
	maintenance?: FieldPolicy<any> | FieldReadFunction<any>,
	other?: FieldPolicy<any> | FieldReadFunction<any>,
	residents?: FieldPolicy<any> | FieldReadFunction<any>,
	roadCharge?: FieldPolicy<any> | FieldReadFunction<any>,
	roadCommunity?: FieldPolicy<any> | FieldReadFunction<any>,
	sanitation?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	waterAndSewage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OpportunityKeySpecifier = ('content' | 'createdAt' | 'id' | 'read' | 'roomType' | 'title' | 'updatedAt' | OpportunityKeySpecifier)[];
export type OpportunityFieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	roomType?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OwnerKeySpecifier = ('name' | 'personalNumber' | OwnerKeySpecifier)[];
export type OwnerFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	personalNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OwnershipKeySpecifier = ('hasMoreThanOneOwner' | 'sellerIsOwner' | OwnershipKeySpecifier)[];
export type OwnershipFieldPolicy = {
	hasMoreThanOneOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	sellerIsOwner?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageInfoKeySpecifier = ('endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'totalCount' | PageInfoKeySpecifier)[];
export type PageInfoFieldPolicy = {
	endCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>,
	startCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PhaseKeySpecifier = ('tasks' | 'type' | PhaseKeySpecifier)[];
export type PhaseFieldPolicy = {
	tasks?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PhotoKeySpecifier = ('url' | PhotoKeySpecifier)[];
export type PhotoFieldPolicy = {
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PhotoShootKeySpecifier = ('approved' | 'includeStaging' | 'photoShootDate' | 'photographer' | 'request' | 'stagingDate' | 'stylist' | PhotoShootKeySpecifier)[];
export type PhotoShootFieldPolicy = {
	approved?: FieldPolicy<any> | FieldReadFunction<any>,
	includeStaging?: FieldPolicy<any> | FieldReadFunction<any>,
	photoShootDate?: FieldPolicy<any> | FieldReadFunction<any>,
	photographer?: FieldPolicy<any> | FieldReadFunction<any>,
	request?: FieldPolicy<any> | FieldReadFunction<any>,
	stagingDate?: FieldPolicy<any> | FieldReadFunction<any>,
	stylist?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlotKeySpecifier = ('area' | PlotKeySpecifier)[];
export type PlotFieldPolicy = {
	area?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PublicFollowerKeySpecifier = ('createdAt' | 'email' | 'homeId' | 'id' | PublicFollowerKeySpecifier)[];
export type PublicFollowerFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	homeId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PublicHomeKeySpecifier = ('adHideArea' | 'adHideCommission' | 'address' | 'area' | 'areaId' | 'areaSource' | 'askingPrice' | 'askingPriceMax' | 'assessment' | 'association' | 'backup' | 'backupId' | 'balcony' | 'biddingState' | 'biddingUrl' | 'bids' | 'building' | 'closingPrice' | 'coordinate' | 'created' | 'description' | 'documents' | 'elevator' | 'energyDeclaration' | 'floor' | 'floorMax' | 'followerCount' | 'id' | 'images' | 'insurance' | 'leasehold' | 'livingArea' | 'livingAreaMax' | 'monthlyFee' | 'monthlyFeeComment' | 'monthlyFeeMax' | 'mortgages' | 'newConstruction' | 'newConstructionAvailable' | 'newConstructionCount' | 'newConstructionEstCompletionDate' | 'newConstructionHome' | 'newConstructionHouseView' | 'newConstructionProjectName' | 'newConstructionSubTenure' | 'numberOfRooms' | 'numberOfRoomsMax' | 'operatingCost' | 'otherArea' | 'patio' | 'pawned' | 'photoRequestCount' | 'plot' | 'preferentialAndCommunityEnrollments' | 'realtor' | 'realtorId' | 'rooms' | 'similarHomes' | 'sortingTimestamp' | 'state' | 'surrounding' | 'tags' | 'tenure' | 'terrace' | 'type' | 'undisclosedAddress' | 'urlExtension' | 'viewings' | 'visitCount' | 'visitorCount' | 'waterAndSewage' | PublicHomeKeySpecifier)[];
export type PublicHomeFieldPolicy = {
	adHideArea?: FieldPolicy<any> | FieldReadFunction<any>,
	adHideCommission?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	area?: FieldPolicy<any> | FieldReadFunction<any>,
	areaId?: FieldPolicy<any> | FieldReadFunction<any>,
	areaSource?: FieldPolicy<any> | FieldReadFunction<any>,
	askingPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	askingPriceMax?: FieldPolicy<any> | FieldReadFunction<any>,
	assessment?: FieldPolicy<any> | FieldReadFunction<any>,
	association?: FieldPolicy<any> | FieldReadFunction<any>,
	backup?: FieldPolicy<any> | FieldReadFunction<any>,
	backupId?: FieldPolicy<any> | FieldReadFunction<any>,
	balcony?: FieldPolicy<any> | FieldReadFunction<any>,
	biddingState?: FieldPolicy<any> | FieldReadFunction<any>,
	biddingUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	bids?: FieldPolicy<any> | FieldReadFunction<any>,
	building?: FieldPolicy<any> | FieldReadFunction<any>,
	closingPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	coordinate?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	documents?: FieldPolicy<any> | FieldReadFunction<any>,
	elevator?: FieldPolicy<any> | FieldReadFunction<any>,
	energyDeclaration?: FieldPolicy<any> | FieldReadFunction<any>,
	floor?: FieldPolicy<any> | FieldReadFunction<any>,
	floorMax?: FieldPolicy<any> | FieldReadFunction<any>,
	followerCount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	images?: FieldPolicy<any> | FieldReadFunction<any>,
	insurance?: FieldPolicy<any> | FieldReadFunction<any>,
	leasehold?: FieldPolicy<any> | FieldReadFunction<any>,
	livingArea?: FieldPolicy<any> | FieldReadFunction<any>,
	livingAreaMax?: FieldPolicy<any> | FieldReadFunction<any>,
	monthlyFee?: FieldPolicy<any> | FieldReadFunction<any>,
	monthlyFeeComment?: FieldPolicy<any> | FieldReadFunction<any>,
	monthlyFeeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	mortgages?: FieldPolicy<any> | FieldReadFunction<any>,
	newConstruction?: FieldPolicy<any> | FieldReadFunction<any>,
	newConstructionAvailable?: FieldPolicy<any> | FieldReadFunction<any>,
	newConstructionCount?: FieldPolicy<any> | FieldReadFunction<any>,
	newConstructionEstCompletionDate?: FieldPolicy<any> | FieldReadFunction<any>,
	newConstructionHome?: FieldPolicy<any> | FieldReadFunction<any>,
	newConstructionHouseView?: FieldPolicy<any> | FieldReadFunction<any>,
	newConstructionProjectName?: FieldPolicy<any> | FieldReadFunction<any>,
	newConstructionSubTenure?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfRooms?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfRoomsMax?: FieldPolicy<any> | FieldReadFunction<any>,
	operatingCost?: FieldPolicy<any> | FieldReadFunction<any>,
	otherArea?: FieldPolicy<any> | FieldReadFunction<any>,
	patio?: FieldPolicy<any> | FieldReadFunction<any>,
	pawned?: FieldPolicy<any> | FieldReadFunction<any>,
	photoRequestCount?: FieldPolicy<any> | FieldReadFunction<any>,
	plot?: FieldPolicy<any> | FieldReadFunction<any>,
	preferentialAndCommunityEnrollments?: FieldPolicy<any> | FieldReadFunction<any>,
	realtor?: FieldPolicy<any> | FieldReadFunction<any>,
	realtorId?: FieldPolicy<any> | FieldReadFunction<any>,
	rooms?: FieldPolicy<any> | FieldReadFunction<any>,
	similarHomes?: FieldPolicy<any> | FieldReadFunction<any>,
	sortingTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	surrounding?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	tenure?: FieldPolicy<any> | FieldReadFunction<any>,
	terrace?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	undisclosedAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	urlExtension?: FieldPolicy<any> | FieldReadFunction<any>,
	viewings?: FieldPolicy<any> | FieldReadFunction<any>,
	visitCount?: FieldPolicy<any> | FieldReadFunction<any>,
	visitorCount?: FieldPolicy<any> | FieldReadFunction<any>,
	waterAndSewage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PublicHomeLikenessKeySpecifier = ('home' | 'id' | 'similarHome' | 'similarity' | PublicHomeLikenessKeySpecifier)[];
export type PublicHomeLikenessFieldPolicy = {
	home?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	similarHome?: FieldPolicy<any> | FieldReadFunction<any>,
	similarity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PublicHomesPaginatedEdgeKeySpecifier = ('cursor' | 'node' | PublicHomesPaginatedEdgeKeySpecifier)[];
export type PublicHomesPaginatedEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PublicHomesPaginatedResultKeySpecifier = ('edges' | 'pageInfo' | PublicHomesPaginatedResultKeySpecifier)[];
export type PublicHomesPaginatedResultFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('CRMActions' | '_empty' | 'area' | 'areas' | 'bankidAuthenticateStatus' | 'chatHandled' | 'chatMessage' | 'chatMessages' | 'chatOwners' | 'devices' | 'followerComment' | 'followerCount' | 'followers' | 'geoJson' | 'home' | 'homeRequests' | 'homes' | 'jobs' | 'lastRead' | 'newConstructionHomes' | 'openMarketRedirects' | 'photoRequests' | 'publicFollowers' | 'publicHome' | 'publicHomeCount' | 'publicHomeFromVitecId' | 'publicHomeMetricDistribution' | 'publicHomes' | 'publicHomesPaginated' | 'rootAreas' | 'searches' | 'temporaryHousingEntries' | 'timeline' | 'user' | 'userAnalyticsEvents' | 'userCount' | 'userLabels' | 'users' | 'usersPaginated' | 'valueGuardCredentials' | 'versions' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	CRMActions?: FieldPolicy<any> | FieldReadFunction<any>,
	_empty?: FieldPolicy<any> | FieldReadFunction<any>,
	area?: FieldPolicy<any> | FieldReadFunction<any>,
	areas?: FieldPolicy<any> | FieldReadFunction<any>,
	bankidAuthenticateStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	chatHandled?: FieldPolicy<any> | FieldReadFunction<any>,
	chatMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	chatMessages?: FieldPolicy<any> | FieldReadFunction<any>,
	chatOwners?: FieldPolicy<any> | FieldReadFunction<any>,
	devices?: FieldPolicy<any> | FieldReadFunction<any>,
	followerComment?: FieldPolicy<any> | FieldReadFunction<any>,
	followerCount?: FieldPolicy<any> | FieldReadFunction<any>,
	followers?: FieldPolicy<any> | FieldReadFunction<any>,
	geoJson?: FieldPolicy<any> | FieldReadFunction<any>,
	home?: FieldPolicy<any> | FieldReadFunction<any>,
	homeRequests?: FieldPolicy<any> | FieldReadFunction<any>,
	homes?: FieldPolicy<any> | FieldReadFunction<any>,
	jobs?: FieldPolicy<any> | FieldReadFunction<any>,
	lastRead?: FieldPolicy<any> | FieldReadFunction<any>,
	newConstructionHomes?: FieldPolicy<any> | FieldReadFunction<any>,
	openMarketRedirects?: FieldPolicy<any> | FieldReadFunction<any>,
	photoRequests?: FieldPolicy<any> | FieldReadFunction<any>,
	publicFollowers?: FieldPolicy<any> | FieldReadFunction<any>,
	publicHome?: FieldPolicy<any> | FieldReadFunction<any>,
	publicHomeCount?: FieldPolicy<any> | FieldReadFunction<any>,
	publicHomeFromVitecId?: FieldPolicy<any> | FieldReadFunction<any>,
	publicHomeMetricDistribution?: FieldPolicy<any> | FieldReadFunction<any>,
	publicHomes?: FieldPolicy<any> | FieldReadFunction<any>,
	publicHomesPaginated?: FieldPolicy<any> | FieldReadFunction<any>,
	rootAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	searches?: FieldPolicy<any> | FieldReadFunction<any>,
	temporaryHousingEntries?: FieldPolicy<any> | FieldReadFunction<any>,
	timeline?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userAnalyticsEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	userCount?: FieldPolicy<any> | FieldReadFunction<any>,
	userLabels?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>,
	usersPaginated?: FieldPolicy<any> | FieldReadFunction<any>,
	valueGuardCredentials?: FieldPolicy<any> | FieldReadFunction<any>,
	versions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RealtorKeySpecifier = ('email' | 'imageId' | 'name' | 'phone' | RealtorKeySpecifier)[];
export type RealtorFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	imageId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RoomKeySpecifier = ('heading' | 'text' | RoomKeySpecifier)[];
export type RoomFieldPolicy = {
	heading?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SearchKeySpecifier = ('areaIds' | 'areas' | 'createdAt' | 'email' | 'homeTypes' | 'id' | 'priceMax' | 'priceMin' | 'roomsMax' | 'roomsMin' | 'sizeMax' | 'sizeMin' | 'user' | SearchKeySpecifier)[];
export type SearchFieldPolicy = {
	areaIds?: FieldPolicy<any> | FieldReadFunction<any>,
	areas?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	homeTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	priceMax?: FieldPolicy<any> | FieldReadFunction<any>,
	priceMin?: FieldPolicy<any> | FieldReadFunction<any>,
	roomsMax?: FieldPolicy<any> | FieldReadFunction<any>,
	roomsMin?: FieldPolicy<any> | FieldReadFunction<any>,
	sizeMax?: FieldPolicy<any> | FieldReadFunction<any>,
	sizeMin?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SessionKeySpecifier = ('id' | 'privateUuid' | 'value' | SessionKeySpecifier)[];
export type SessionFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	privateUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SessionLoginEmailResultKeySpecifier = ('emailChallengeAntiPhishingCode' | 'emailChallengeSent' | 'newAccountCreated' | SessionLoginEmailResultKeySpecifier)[];
export type SessionLoginEmailResultFieldPolicy = {
	emailChallengeAntiPhishingCode?: FieldPolicy<any> | FieldReadFunction<any>,
	emailChallengeSent?: FieldPolicy<any> | FieldReadFunction<any>,
	newAccountCreated?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SessionMutationResultKeySpecifier = ('loginEmailResult' | SessionMutationResultKeySpecifier)[];
export type SessionMutationResultFieldPolicy = {
	loginEmailResult?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SessionValueKeySpecifier = ('id' | 'jwt' | 'mutationResult' | 'state' | SessionValueKeySpecifier)[];
export type SessionValueFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	jwt?: FieldPolicy<any> | FieldReadFunction<any>,
	mutationResult?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionKeySpecifier = ('_empty' | 'chatMessageCreated' | 'homeUpdated' | 'logEntryCreated' | SubscriptionKeySpecifier)[];
export type SubscriptionFieldPolicy = {
	_empty?: FieldPolicy<any> | FieldReadFunction<any>,
	chatMessageCreated?: FieldPolicy<any> | FieldReadFunction<any>,
	homeUpdated?: FieldPolicy<any> | FieldReadFunction<any>,
	logEntryCreated?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurroundingKeySpecifier = ('communication' | 'general' | 'other' | 'parking' | 'services' | SurroundingKeySpecifier)[];
export type SurroundingFieldPolicy = {
	communication?: FieldPolicy<any> | FieldReadFunction<any>,
	general?: FieldPolicy<any> | FieldReadFunction<any>,
	other?: FieldPolicy<any> | FieldReadFunction<any>,
	parking?: FieldPolicy<any> | FieldReadFunction<any>,
	services?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SyncFollowerErrorKeySpecifier = ('id' | 'message' | 'type' | 'validationErrors' | SyncFollowerErrorKeySpecifier)[];
export type SyncFollowerErrorFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	validationErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SyncFollowerErrorsKeySpecifier = ('errors' | SyncFollowerErrorsKeySpecifier)[];
export type SyncFollowerErrorsFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskKeySpecifier = ('phase' | 'state' | 'type' | TaskKeySpecifier)[];
export type TaskFieldPolicy = {
	phase?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TemporaryHousingEntryKeySpecifier = ('city' | 'email' | 'endDate' | 'id' | 'name' | 'phoneNumber' | 'rooms' | 'startDate' | TemporaryHousingEntryKeySpecifier)[];
export type TemporaryHousingEntryFieldPolicy = {
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	rooms?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TimelineKeySpecifier = ('currentTask' | 'currentTaskState' | 'pendingTasks' | 'tasks' | TimelineKeySpecifier)[];
export type TimelineFieldPolicy = {
	currentTask?: FieldPolicy<any> | FieldReadFunction<any>,
	currentTaskState?: FieldPolicy<any> | FieldReadFunction<any>,
	pendingTasks?: FieldPolicy<any> | FieldReadFunction<any>,
	tasks?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UndisclosedAddressKeySpecifier = ('latitude' | 'longitude' | 'name' | UndisclosedAddressKeySpecifier)[];
export type UndisclosedAddressFieldPolicy = {
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserKeySpecifier = ('CRMActions' | 'activityScore' | 'bankInformation' | 'createdAt' | 'displayName' | 'email' | 'files' | 'home' | 'id' | 'logEntries' | 'logEntry' | 'name' | 'phone' | 'photoURL' | 'pin' | 'recommendations' | 'role' | 'unreadMessages' | 'unsubscribeFollowerMail' | 'unsubscribeRecommendationMail' | 'userLabels' | UserKeySpecifier)[];
export type UserFieldPolicy = {
	CRMActions?: FieldPolicy<any> | FieldReadFunction<any>,
	activityScore?: FieldPolicy<any> | FieldReadFunction<any>,
	bankInformation?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	files?: FieldPolicy<any> | FieldReadFunction<any>,
	home?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	logEntries?: FieldPolicy<any> | FieldReadFunction<any>,
	logEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	photoURL?: FieldPolicy<any> | FieldReadFunction<any>,
	pin?: FieldPolicy<any> | FieldReadFunction<any>,
	recommendations?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	unreadMessages?: FieldPolicy<any> | FieldReadFunction<any>,
	unsubscribeFollowerMail?: FieldPolicy<any> | FieldReadFunction<any>,
	unsubscribeRecommendationMail?: FieldPolicy<any> | FieldReadFunction<any>,
	userLabels?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserDataDtoKeySpecifier = ('clientIpAddress' | 'clientUserAgent' | 'externalId' | 'homeId' | 'userId' | UserDataDtoKeySpecifier)[];
export type UserDataDtoFieldPolicy = {
	clientIpAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	clientUserAgent?: FieldPolicy<any> | FieldReadFunction<any>,
	externalId?: FieldPolicy<any> | FieldReadFunction<any>,
	homeId?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserFileKeySpecifier = ('createdAt' | 'deleted' | 'filename' | 'id' | 'mimetype' | 'signedUrl' | 'updatedAt' | UserFileKeySpecifier)[];
export type UserFileFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deleted?: FieldPolicy<any> | FieldReadFunction<any>,
	filename?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	mimetype?: FieldPolicy<any> | FieldReadFunction<any>,
	signedUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserFilesignedUrlKeySpecifier = ('expiresAt' | 'url' | UserFilesignedUrlKeySpecifier)[];
export type UserFilesignedUrlFieldPolicy = {
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserLabelKeySpecifier = ('id' | 'label' | 'teamsHook' | UserLabelKeySpecifier)[];
export type UserLabelFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	teamsHook?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserPaginatedEdgeKeySpecifier = ('cursor' | 'node' | UserPaginatedEdgeKeySpecifier)[];
export type UserPaginatedEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserPaginatedResultKeySpecifier = ('edges' | 'pageInfo' | UserPaginatedResultKeySpecifier)[];
export type UserPaginatedResultFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ValuationMeetingInfoKeySpecifier = ('buildingYear' | 'date' | 'entryCode' | 'fee' | 'location' | 'notes' | 'ownership' | 'participants' | 'renovations' | 'request' | 'result' | 'tenure' | ValuationMeetingInfoKeySpecifier)[];
export type ValuationMeetingInfoFieldPolicy = {
	buildingYear?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	entryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	fee?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	ownership?: FieldPolicy<any> | FieldReadFunction<any>,
	participants?: FieldPolicy<any> | FieldReadFunction<any>,
	renovations?: FieldPolicy<any> | FieldReadFunction<any>,
	request?: FieldPolicy<any> | FieldReadFunction<any>,
	result?: FieldPolicy<any> | FieldReadFunction<any>,
	tenure?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ValueGuardCredentialsKeySpecifier = ('password' | 'user' | ValueGuardCredentialsKeySpecifier)[];
export type ValueGuardCredentialsFieldPolicy = {
	password?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VersionsKeySpecifier = ('minAppVersion' | VersionsKeySpecifier)[];
export type VersionsFieldPolicy = {
	minAppVersion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ViewingKeySpecifier = ('endsAt' | 'id' | 'maxNbrOfParticipants' | 'nbrOfBooked' | 'startsAt' | 'timeSlots' | 'unspecifiedTime' | ViewingKeySpecifier)[];
export type ViewingFieldPolicy = {
	endsAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	maxNbrOfParticipants?: FieldPolicy<any> | FieldReadFunction<any>,
	nbrOfBooked?: FieldPolicy<any> | FieldReadFunction<any>,
	startsAt?: FieldPolicy<any> | FieldReadFunction<any>,
	timeSlots?: FieldPolicy<any> | FieldReadFunction<any>,
	unspecifiedTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ViewingTimeSlotKeySpecifier = ('endsAt' | 'id' | 'startsAt' | ViewingTimeSlotKeySpecifier)[];
export type ViewingTimeSlotFieldPolicy = {
	endsAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	startsAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WaterAndSewageKeySpecifier = ('info' | WaterAndSewageKeySpecifier)[];
export type WaterAndSewageFieldPolicy = {
	info?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	AccessMeeting?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccessMeetingKeySpecifier | (() => undefined | AccessMeetingKeySpecifier),
		fields?: AccessMeetingFieldPolicy,
	},
	Address?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddressKeySpecifier | (() => undefined | AddressKeySpecifier),
		fields?: AddressFieldPolicy,
	},
	AggregatedEventDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AggregatedEventDtoKeySpecifier | (() => undefined | AggregatedEventDtoKeySpecifier),
		fields?: AggregatedEventDtoFieldPolicy,
	},
	Area?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AreaKeySpecifier | (() => undefined | AreaKeySpecifier),
		fields?: AreaFieldPolicy,
	},
	Assessment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssessmentKeySpecifier | (() => undefined | AssessmentKeySpecifier),
		fields?: AssessmentFieldPolicy,
	},
	Association?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssociationKeySpecifier | (() => undefined | AssociationKeySpecifier),
		fields?: AssociationFieldPolicy,
	},
	BankInformation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BankInformationKeySpecifier | (() => undefined | BankInformationKeySpecifier),
		fields?: BankInformationFieldPolicy,
	},
	BankidInitResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BankidInitResponseKeySpecifier | (() => undefined | BankidInitResponseKeySpecifier),
		fields?: BankidInitResponseFieldPolicy,
	},
	BankidStatusResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BankidStatusResponseKeySpecifier | (() => undefined | BankidStatusResponseKeySpecifier),
		fields?: BankidStatusResponseFieldPolicy,
	},
	BankidUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BankidUserKeySpecifier | (() => undefined | BankidUserKeySpecifier),
		fields?: BankidUserFieldPolicy,
	},
	Bid?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BidKeySpecifier | (() => undefined | BidKeySpecifier),
		fields?: BidFieldPolicy,
	},
	Bounds?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BoundsKeySpecifier | (() => undefined | BoundsKeySpecifier),
		fields?: BoundsFieldPolicy,
	},
	Building?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BuildingKeySpecifier | (() => undefined | BuildingKeySpecifier),
		fields?: BuildingFieldPolicy,
	},
	CRMAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CRMActionKeySpecifier | (() => undefined | CRMActionKeySpecifier),
		fields?: CRMActionFieldPolicy,
	},
	ChatMessage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChatMessageKeySpecifier | (() => undefined | ChatMessageKeySpecifier),
		fields?: ChatMessageFieldPolicy,
	},
	ChatOwnership?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChatOwnershipKeySpecifier | (() => undefined | ChatOwnershipKeySpecifier),
		fields?: ChatOwnershipFieldPolicy,
	},
	ContractMeeting?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContractMeetingKeySpecifier | (() => undefined | ContractMeetingKeySpecifier),
		fields?: ContractMeetingFieldPolicy,
	},
	Coordinate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CoordinateKeySpecifier | (() => undefined | CoordinateKeySpecifier),
		fields?: CoordinateFieldPolicy,
	},
	Description?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DescriptionKeySpecifier | (() => undefined | DescriptionKeySpecifier),
		fields?: DescriptionFieldPolicy,
	},
	Device?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeviceKeySpecifier | (() => undefined | DeviceKeySpecifier),
		fields?: DeviceFieldPolicy,
	},
	DeviceDataDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeviceDataDtoKeySpecifier | (() => undefined | DeviceDataDtoKeySpecifier),
		fields?: DeviceDataDtoFieldPolicy,
	},
	Distribution?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DistributionKeySpecifier | (() => undefined | DistributionKeySpecifier),
		fields?: DistributionFieldPolicy,
	},
	Document?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DocumentKeySpecifier | (() => undefined | DocumentKeySpecifier),
		fields?: DocumentFieldPolicy,
	},
	Email?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmailKeySpecifier | (() => undefined | EmailKeySpecifier),
		fields?: EmailFieldPolicy,
	},
	EnergyDeclaration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnergyDeclarationKeySpecifier | (() => undefined | EnergyDeclarationKeySpecifier),
		fields?: EnergyDeclarationFieldPolicy,
	},
	Follower?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FollowerKeySpecifier | (() => undefined | FollowerKeySpecifier),
		fields?: FollowerFieldPolicy,
	},
	FollowerComment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FollowerCommentKeySpecifier | (() => undefined | FollowerCommentKeySpecifier),
		fields?: FollowerCommentFieldPolicy,
	},
	FollowerRecommendation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FollowerRecommendationKeySpecifier | (() => undefined | FollowerRecommendationKeySpecifier),
		fields?: FollowerRecommendationFieldPolicy,
	},
	Home?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HomeKeySpecifier | (() => undefined | HomeKeySpecifier),
		fields?: HomeFieldPolicy,
	},
	HomeLogEntry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HomeLogEntryKeySpecifier | (() => undefined | HomeLogEntryKeySpecifier),
		fields?: HomeLogEntryFieldPolicy,
	},
	HomeMetricDistribution?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HomeMetricDistributionKeySpecifier | (() => undefined | HomeMetricDistributionKeySpecifier),
		fields?: HomeMetricDistributionFieldPolicy,
	},
	HomeRequest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HomeRequestKeySpecifier | (() => undefined | HomeRequestKeySpecifier),
		fields?: HomeRequestFieldPolicy,
	},
	HomeRequestPhotos?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HomeRequestPhotosKeySpecifier | (() => undefined | HomeRequestPhotosKeySpecifier),
		fields?: HomeRequestPhotosFieldPolicy,
	},
	Homes?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HomesKeySpecifier | (() => undefined | HomesKeySpecifier),
		fields?: HomesFieldPolicy,
	},
	Image?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImageKeySpecifier | (() => undefined | ImageKeySpecifier),
		fields?: ImageFieldPolicy,
	},
	Insurance?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InsuranceKeySpecifier | (() => undefined | InsuranceKeySpecifier),
		fields?: InsuranceFieldPolicy,
	},
	Job?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | JobKeySpecifier | (() => undefined | JobKeySpecifier),
		fields?: JobFieldPolicy,
	},
	Leasehold?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LeaseholdKeySpecifier | (() => undefined | LeaseholdKeySpecifier),
		fields?: LeaseholdFieldPolicy,
	},
	LogEntry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LogEntryKeySpecifier | (() => undefined | LogEntryKeySpecifier),
		fields?: LogEntryFieldPolicy,
	},
	Mortgage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MortgageKeySpecifier | (() => undefined | MortgageKeySpecifier),
		fields?: MortgageFieldPolicy,
	},
	Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier),
		fields?: MutationFieldPolicy,
	},
	NewConstructionHome?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NewConstructionHomeKeySpecifier | (() => undefined | NewConstructionHomeKeySpecifier),
		fields?: NewConstructionHomeFieldPolicy,
	},
	OpenMarket?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OpenMarketKeySpecifier | (() => undefined | OpenMarketKeySpecifier),
		fields?: OpenMarketFieldPolicy,
	},
	OpenMarketRedirect?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OpenMarketRedirectKeySpecifier | (() => undefined | OpenMarketRedirectKeySpecifier),
		fields?: OpenMarketRedirectFieldPolicy,
	},
	OperatingCost?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OperatingCostKeySpecifier | (() => undefined | OperatingCostKeySpecifier),
		fields?: OperatingCostFieldPolicy,
	},
	Opportunity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OpportunityKeySpecifier | (() => undefined | OpportunityKeySpecifier),
		fields?: OpportunityFieldPolicy,
	},
	Owner?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OwnerKeySpecifier | (() => undefined | OwnerKeySpecifier),
		fields?: OwnerFieldPolicy,
	},
	Ownership?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OwnershipKeySpecifier | (() => undefined | OwnershipKeySpecifier),
		fields?: OwnershipFieldPolicy,
	},
	PageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageInfoKeySpecifier | (() => undefined | PageInfoKeySpecifier),
		fields?: PageInfoFieldPolicy,
	},
	Phase?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PhaseKeySpecifier | (() => undefined | PhaseKeySpecifier),
		fields?: PhaseFieldPolicy,
	},
	Photo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PhotoKeySpecifier | (() => undefined | PhotoKeySpecifier),
		fields?: PhotoFieldPolicy,
	},
	PhotoShoot?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PhotoShootKeySpecifier | (() => undefined | PhotoShootKeySpecifier),
		fields?: PhotoShootFieldPolicy,
	},
	Plot?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlotKeySpecifier | (() => undefined | PlotKeySpecifier),
		fields?: PlotFieldPolicy,
	},
	PublicFollower?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PublicFollowerKeySpecifier | (() => undefined | PublicFollowerKeySpecifier),
		fields?: PublicFollowerFieldPolicy,
	},
	PublicHome?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PublicHomeKeySpecifier | (() => undefined | PublicHomeKeySpecifier),
		fields?: PublicHomeFieldPolicy,
	},
	PublicHomeLikeness?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PublicHomeLikenessKeySpecifier | (() => undefined | PublicHomeLikenessKeySpecifier),
		fields?: PublicHomeLikenessFieldPolicy,
	},
	PublicHomesPaginatedEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PublicHomesPaginatedEdgeKeySpecifier | (() => undefined | PublicHomesPaginatedEdgeKeySpecifier),
		fields?: PublicHomesPaginatedEdgeFieldPolicy,
	},
	PublicHomesPaginatedResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PublicHomesPaginatedResultKeySpecifier | (() => undefined | PublicHomesPaginatedResultKeySpecifier),
		fields?: PublicHomesPaginatedResultFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	Realtor?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RealtorKeySpecifier | (() => undefined | RealtorKeySpecifier),
		fields?: RealtorFieldPolicy,
	},
	Room?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RoomKeySpecifier | (() => undefined | RoomKeySpecifier),
		fields?: RoomFieldPolicy,
	},
	Search?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SearchKeySpecifier | (() => undefined | SearchKeySpecifier),
		fields?: SearchFieldPolicy,
	},
	Session?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SessionKeySpecifier | (() => undefined | SessionKeySpecifier),
		fields?: SessionFieldPolicy,
	},
	SessionLoginEmailResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SessionLoginEmailResultKeySpecifier | (() => undefined | SessionLoginEmailResultKeySpecifier),
		fields?: SessionLoginEmailResultFieldPolicy,
	},
	SessionMutationResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SessionMutationResultKeySpecifier | (() => undefined | SessionMutationResultKeySpecifier),
		fields?: SessionMutationResultFieldPolicy,
	},
	SessionValue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SessionValueKeySpecifier | (() => undefined | SessionValueKeySpecifier),
		fields?: SessionValueFieldPolicy,
	},
	Subscription?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionKeySpecifier | (() => undefined | SubscriptionKeySpecifier),
		fields?: SubscriptionFieldPolicy,
	},
	Surrounding?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurroundingKeySpecifier | (() => undefined | SurroundingKeySpecifier),
		fields?: SurroundingFieldPolicy,
	},
	SyncFollowerError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SyncFollowerErrorKeySpecifier | (() => undefined | SyncFollowerErrorKeySpecifier),
		fields?: SyncFollowerErrorFieldPolicy,
	},
	SyncFollowerErrors?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SyncFollowerErrorsKeySpecifier | (() => undefined | SyncFollowerErrorsKeySpecifier),
		fields?: SyncFollowerErrorsFieldPolicy,
	},
	Task?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskKeySpecifier | (() => undefined | TaskKeySpecifier),
		fields?: TaskFieldPolicy,
	},
	TemporaryHousingEntry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TemporaryHousingEntryKeySpecifier | (() => undefined | TemporaryHousingEntryKeySpecifier),
		fields?: TemporaryHousingEntryFieldPolicy,
	},
	Timeline?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TimelineKeySpecifier | (() => undefined | TimelineKeySpecifier),
		fields?: TimelineFieldPolicy,
	},
	UndisclosedAddress?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UndisclosedAddressKeySpecifier | (() => undefined | UndisclosedAddressKeySpecifier),
		fields?: UndisclosedAddressFieldPolicy,
	},
	User?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserKeySpecifier | (() => undefined | UserKeySpecifier),
		fields?: UserFieldPolicy,
	},
	UserDataDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserDataDtoKeySpecifier | (() => undefined | UserDataDtoKeySpecifier),
		fields?: UserDataDtoFieldPolicy,
	},
	UserFile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserFileKeySpecifier | (() => undefined | UserFileKeySpecifier),
		fields?: UserFileFieldPolicy,
	},
	UserFilesignedUrl?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserFilesignedUrlKeySpecifier | (() => undefined | UserFilesignedUrlKeySpecifier),
		fields?: UserFilesignedUrlFieldPolicy,
	},
	UserLabel?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserLabelKeySpecifier | (() => undefined | UserLabelKeySpecifier),
		fields?: UserLabelFieldPolicy,
	},
	UserPaginatedEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserPaginatedEdgeKeySpecifier | (() => undefined | UserPaginatedEdgeKeySpecifier),
		fields?: UserPaginatedEdgeFieldPolicy,
	},
	UserPaginatedResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserPaginatedResultKeySpecifier | (() => undefined | UserPaginatedResultKeySpecifier),
		fields?: UserPaginatedResultFieldPolicy,
	},
	ValuationMeetingInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ValuationMeetingInfoKeySpecifier | (() => undefined | ValuationMeetingInfoKeySpecifier),
		fields?: ValuationMeetingInfoFieldPolicy,
	},
	ValueGuardCredentials?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ValueGuardCredentialsKeySpecifier | (() => undefined | ValueGuardCredentialsKeySpecifier),
		fields?: ValueGuardCredentialsFieldPolicy,
	},
	Versions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VersionsKeySpecifier | (() => undefined | VersionsKeySpecifier),
		fields?: VersionsFieldPolicy,
	},
	Viewing?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ViewingKeySpecifier | (() => undefined | ViewingKeySpecifier),
		fields?: ViewingFieldPolicy,
	},
	ViewingTimeSlot?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ViewingTimeSlotKeySpecifier | (() => undefined | ViewingTimeSlotKeySpecifier),
		fields?: ViewingTimeSlotFieldPolicy,
	},
	WaterAndSewage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WaterAndSewageKeySpecifier | (() => undefined | WaterAndSewageKeySpecifier),
		fields?: WaterAndSewageFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;